
// import React, { useState, useEffect, useCallback, useMemo, useRef } from 'react';
// import { Link, useNavigate, useLocation } from 'react-router-dom';
// import { getLoggedInUser } from '../../utils/authHelper';
// import {
//     IoAdd,
//     IoTrashOutline,
//     IoSearchOutline,
//     IoChevronDown,
//     IoFlagOutline,
//     IoGridOutline,
//     IoListOutline,
//     IoBriefcaseOutline,
//     IoPeopleOutline,
//     IoCheckmarkCircleOutline,
//     IoPricetagOutline,
//     IoCalendarOutline,
//     IoChatbubbleEllipsesOutline,
//     IoCheckmarkDoneCircleOutline,
//     IoRefresh,
//     IoGitNetworkOutline,
//     IoWarningOutline,
//     IoCopyOutline,
//     IoReorderFourOutline,
//     IoBusinessOutline,
//     IoDocumentsOutline,
//     IoClose,
//     IoChevronForwardOutline,
//     IoCreateOutline,
//     IoPersonAddOutline,
//     IoEyeOutline,
//     IoReturnDownForwardOutline,
// } from 'react-icons/io5';
// import './TasksListPagestyle.css';

// // --- Custom hook for debouncing input ---
// const useDebounce = (value, delay) => {
//     const [debouncedValue, setDebouncedValue] = useState(value);
//     useEffect(() => {
//         const handler = setTimeout(() => {
//             setDebouncedValue(value);
//         }, delay);
//         return () => {
//             clearTimeout(handler);
//         };
//     }, [value, delay]);
//     return debouncedValue;
// };


// // --- Configuration & API ---
// const SWAGGER_BASE_URL = process.env.REACT_APP_SWAGGER_SERVICE_BASE_URL;
// const NODE_BASE_URL = process.env.REACT_APP_NODE_SERVICE_BASE_URL;
// const AUTH_TOKEN_KEY = 'zTaskAuthToken';
// const TASKS_PER_PAGE = 20;
// const SESSION_STORAGE_KEY = 'taskListPageState';

// const getAuthToken = () => localStorage.getItem(AUTH_TOKEN_KEY);
// const getApiHeaders = () => ({ 'Authorization': `Bearer ${getAuthToken()}`, 'accept': 'application/json' });

// const getDraftsByTemplateId = async (templateId) => {
//     const response = await fetch(`${SWAGGER_BASE_URL}/api/get-all-draft-task-by-template-id?templateId=${templateId}`, { headers: getApiHeaders() });
//     if (!response.ok) {
//         if (response.status === 404 || response.status === 400) {
//             return { draft_tasks: [] };
//         }
//         throw new Error(`Failed to fetch drafts for template ${templateId}`);
//     }
//     return response.json();
// };

// const deleteDraftTaskApi = async (draftTaskId) => {
//     const response = await fetch(`${SWAGGER_BASE_URL}/api/delete-draft-task?draftTaskId=${draftTaskId}`, {
//         method: 'DELETE',
//         headers: getApiHeaders(),
//     });
//     if (!response.ok) {
//         const errorData = await response.json().catch(() => ({}));
//         throw new Error(errorData.message || 'Could not delete draft task');
//     }
//     return response.json();
// };

// const updateDraftAssigneeApi = async (draftTaskId, userId) => {
//     const response = await fetch(`${SWAGGER_BASE_URL}/api/update-assignee-in-draft-task?draftTaskId=${draftTaskId}&userId=${userId}`, {
//         method: 'PUT',
//         headers: getApiHeaders(),
//     });
//     if (!response.ok) {
//         const errorData = await response.json().catch(() => ({}));
//         throw new Error(errorData.message || 'Could not update draft task assignee');
//     }
//     return response.json();
// };


// // --- Date Helpers ---
// const pad = (num) => num.toString().padStart(2, '0');
// const today = new Date();
// const currentYear = today.getFullYear();
// const currentMonth = today.getMonth() + 1;
// const currentDay = today.getDate();

// const years = Array.from({ length: 101 }, (_, i) => currentYear - 50 + i);
// const DATE_PICKER_MONTHS = [
//     { value: '1', name: 'Jan' }, { value: '2', name: 'Feb' }, { value: '3', name: 'Mar' },
//     { value: '4', name: 'Apr' }, { value: '5', name: 'May' }, { value: '6', name: 'Jun' },
//     { value: '7', name: 'Jul' }, { value: '8', name: 'Aug' }, { value: '9', name: 'Sep' },
//     { value: '10', name: 'Oct' }, { value: '11', name: 'Nov' }, { value: '12', name: 'Dec' }
// ];
// const getDaysInMonth = (year, month) => new Date(parseInt(year, 10), parseInt(month, 10), 0).getDate();

// // Unified Normalization Helper
// const normalizeForComparison = (str) => String(str || '').toLowerCase().trim().replace(/[\s-]/g, '_');

// const getStatusClass = (status) => status ? normalizeForComparison(status).replace(/_/g, '-') : 'default';

// // --- API & Utility Functions ---
// const getCompanyDetailsAPI = async () => {
//     const response = await fetch(`${SWAGGER_BASE_URL}/api/get-company`, { headers: getApiHeaders() });
//     if (!response.ok) throw new Error('Failed to fetch company details');
//     return response.json();
// };

// const getSubTasksAPI = async (parentTaskId) => {
//     const response = await fetch(`${SWAGGER_BASE_URL}/api/get-sub-tasks?parentTaskId=${parentTaskId}`, { headers: getApiHeaders() });
//     if (response.status === 400) {
//         const errorData = await response.json().catch(() => ({}));
//         if (errorData.message === "sub task list is empty") { return []; }
//     }
//     if (!response.ok) throw new Error(`Failed to fetch subtasks for task ${parentTaskId}: ${response.status}`);
//     const data = await response.json();
//     return data.data || [];
// };

// const getCustomersAPI = async () => {
//     const response = await fetch(`${NODE_BASE_URL}/customer/api/customers/`, { headers: getApiHeaders() });
//     if (!response.ok) throw new Error(`Failed to fetch customers: ${response.status}`);
//     return response.json();
// };

// const fetchHierarchyAPI = async () => {
//     const response = await fetch(`${SWAGGER_BASE_URL}/api-get-full-hierarchy-tree`, { headers: getApiHeaders() });
//     if (!response.ok) throw new Error(`Failed to fetch hierarchy: ${response.status}`);
//     return (await response.json()).tree || [];
// };

// const getCommonMasterColumnAPI = async (columnName) => {
//     const response = await fetch(`${NODE_BASE_URL}/api/get-column/common_master/${columnName}`, { headers: getApiHeaders() });
//     if (!response.ok) throw new Error(`Failed to fetch ${columnName}: ${response.status}`);
//     return response.json();
// };

// const getProjectTemplatesAPI = async () => {
//     const response = await fetch(`${SWAGGER_BASE_URL}/api/get-Project Template`, { headers: getApiHeaders() });
//     if (!response.ok) throw new Error('Failed to fetch project templates');
//     const data = await response.json();
//     return data.project_template || [];
// };

// const getTasksByUserIdAPI = async (userId, page = 1, size = TASKS_PER_PAGE) => {
//     if (!userId) {
//         console.warn('getTasksByUserIdAPI was called with an invalid userId:', userId);
//         return [];
//     }
//     const response = await fetch(`${SWAGGER_BASE_URL}/api/get-task-by-userId?userId=${userId}&page=${page}&size=${size}`, { headers: getApiHeaders() });
//     if (response.status === 404) return [];
//     if (!response.ok) throw new Error(`Failed to fetch tasks for user ${userId}: ${response.status}`);
//     const data = await response.json();
//     return (data.data || []).map(task => ({
//         taskId: task.task_id,
//         parentTaskId: task.parent_task_id,
//         title: task.title,
//         description: task.description,
//         status: task.status,
//         priority: task.priority,
//         assigneeName: task.assignee_name,
//         category: task.category,
//         createdBy: task.created_by,
//         completedAt: task.completed_at,
//         remainingTime: task.remaining_time,
//         no_of_sub_tasks: task.no_of_sub_tasks,
//         projectName: task.project_name,
//         remarks: task.remarks,
//         comments: task.comments,
//         createdAt: task.created_at,
//         updatedAt: task.updated_at,
//         dueDate: task.due_date,
//         customerId: task.customer_id,
//         projectId: task.project_id,
//         assigneeId: task.assignee_id
//     }));
// };

// const getUsers = async () => {
//     const response = await fetch(`${SWAGGER_BASE_URL}/api/get-users`, { headers: getApiHeaders() });
//     if (!response.ok) throw new Error('Failed to fetch users');
//     return (await response.json()).userData || [];
// };

// const deleteTaskApi = async (taskId) => {
//     const response = await fetch(`${SWAGGER_BASE_URL}/api/delete-task?taskId=${taskId}`, { method: 'DELETE', headers: getApiHeaders() });
//     if (!response.ok) {
//         const errorData = await response.json().catch(() => ({}));
//         throw new Error(errorData.message || 'Failed to delete task');
//     }
//     return response.json();
// };

// const getTaggedTasksAPI = async () => {
//     const response = await fetch(`${SWAGGER_BASE_URL}/api/get-tagged-tasks-id`, { headers: getApiHeaders() });
//     if (!response.ok) {
//         console.error('Failed to fetch tagged task IDs, color-coding will be disabled.');
//         return [];
//     }
//     const data = await response.json();
//     return (data.tagged_task_ids || []).map(item => item.task_id);
// };

// const groupDraftsIntoSessions = (flatDraftTasks, template) => {
//     if (!flatDraftTasks || flatDraftTasks.length === 0) {
//         return [];
//     }
//     const sessionsMap = new Map();
//     flatDraftTasks.forEach(task => {
//         const groupKey = task.createdAt ? new Date(task.createdAt).setMilliseconds(0).toString() : 'no-timestamp';
//         if (!sessionsMap.has(groupKey)) {
//             sessionsMap.set(groupKey, []);
//         }
//         sessionsMap.get(groupKey).push(task);
//     });
//     const sessions = [];
//     for (const [timestampKey, tasksInSession] of sessionsMap.entries()) {
//         if (tasksInSession.length > 0) {
//             const representativeTask = tasksInSession.find(t => t.parentTaskId === 0) || tasksInSession[0];
//             sessions.push({
//                 sessionId: representativeTask.draftTaskId,
//                 savedAt: representativeTask.createdAt,
//                 createdBy: representativeTask.createdBy,
//                 assigneeName: representativeTask.assigneeName,
//                 displayName: `Draft: "${representativeTask.title}"`,
//                 template: template,
//                 tasks: tasksInSession,
//             });
//         }
//     }
//     return sessions;
// };

// const getSubordinateIds = (node) => {
//     if (!node) return [];
//     let ids = [node.id];
//     (node.children || []).forEach(child => { ids = ids.concat(getSubordinateIds(child)); });
//     return ids;
// };

// const getFinancialYear = (date) => {
//     if (!date || isNaN(new Date(date))) return null;
//     const d = new Date(date);
//     const year = d.getFullYear();
//     const month = d.getMonth();
//     return month >= 3 ? `${year}-${year + 1}` : `${year - 1}-${year}`;
// };

// const filterActiveHierarchy = (nodes) => {
//     if (!Array.isArray(nodes)) return [];
//     return nodes
//         .filter(node => node.active === true)
//         .map(node => ({ ...node, children: filterActiveHierarchy(node.children), }));
// };

// const taskMatchesFilters = (task, userNode, filters) => {
//     if (!task || !userNode || !filters) return false;

//     if (filters.taskId) {
//         return String(task.taskId) === filters.taskId;
//     }

//     if (task.parentTaskId) return false;
//     const { searchTerm, status, priority, projectName, userId, category, year, month, dateFilterType, dateFrom, dateTo, department, vendorTypes, customers, suppliers } = filters;
//     if (userId.length > 0 && !userId.includes(String(task.assigneeId))) return false;
//     if (vendorTypes.length > 0 && (task.vendorTypeId == null || !vendorTypes.includes(String(task.vendorTypeId)))) return false;
//     const selectedVendors = [...customers, ...suppliers];
//     if (selectedVendors.length > 0 && (task.customerId == null || !selectedVendors.includes(String(task.customerId)))) return false;
//     if (department.length > 0) {
//         const userDepartmentName = userNode.department?.departmentName?.replace(/ /g, '_');
//         if (!userDepartmentName || !department.includes(userDepartmentName)) return false;
//     }

//     if (status.length > 0) {
//         const taskStatusKey = normalizeForComparison(task.status);
//         const filterStatusKeys = status.map(normalizeForComparison);
//         if (!filterStatusKeys.includes(taskStatusKey)) return false;
//     }
//     if (priority.length > 0) {
//         const taskPriorityKey = normalizeForComparison(task.priority);
//         const filterPriorityKeys = priority.map(normalizeForComparison);
//         if (!filterPriorityKeys.includes(taskPriorityKey)) return false;
//     }
//     if (projectName.length > 0) {
//         const normalizedTaskProjectName = normalizeForComparison(task.projectName);
//         const normalizedFilterProjects = projectName.map(normalizeForComparison);
//         if (!normalizedFilterProjects.includes(normalizedTaskProjectName)) return false;
//     }
//     if (category.length > 0) {
//         const normalizedTaskCategory = normalizeForComparison(task.category);
//         const normalizedFilterCategories = category.map(normalizeForComparison);
//         if (!normalizedFilterCategories.includes(normalizedTaskCategory)) return false;
//     }

//     if (year.length > 0 || month.length > 0) {
//         if (!task.createdAt) return false;
//         const taskDate = new Date(task.createdAt);
//         if (isNaN(taskDate.getTime())) return false;
//         if (year.length > 0) {
//             const financialYear = getFinancialYear(task.createdAt);
//             if (!financialYear || !year.includes(financialYear)) {
//                 return false;
//             }
//         }
//         if (month.length > 0 && !month.map(Number).includes(taskDate.getMonth() + 1)) {
//             return false;
//         }
//     }
//     if (dateFilterType !== 'none' && dateFrom && dateTo) {
//         let taskDateString;
//         if (dateFilterType === 'created') taskDateString = task.createdAt;
//         else if (dateFilterType === 'completed') taskDateString = task.completedAt;
//         else if (dateFilterType === 'due') taskDateString = task.dueDate;
//         if (!taskDateString) return false;
//         try {
//             const taskDate = new Date(taskDateString); taskDate.setHours(0, 0, 0, 0);
//             const fromDate = new Date(dateFrom); fromDate.setHours(0, 0, 0, 0);
//             const toDate = new Date(dateTo); toDate.setHours(23, 59, 59, 999);
//             if (taskDate < fromDate || taskDate > toDate) return false;
//         } catch (e) { return false; }
//     }
//     const lowerSearchTerm = searchTerm.toLowerCase().trim();
//     if (!lowerSearchTerm) return true;
//     const commentsMatch = task.comments?.some(comment => comment && comment.toLowerCase().includes(lowerSearchTerm));
//     return (
//         task.title?.toLowerCase().includes(lowerSearchTerm) ||
//         task.description?.toLowerCase().includes(lowerSearchTerm) ||
//         task.taskId?.toString().includes(lowerSearchTerm) ||
//         userNode.name?.toLowerCase().includes(lowerSearchTerm) ||
//         task.projectName?.toLowerCase().replace(/_/g, ' ').includes(lowerSearchTerm) ||
//         task.customerName?.toLowerCase().includes(lowerSearchTerm) ||
//         task.status?.toLowerCase().replace(/[\s_-]/g, ' ').includes(lowerSearchTerm) ||
//         task.priority?.toLowerCase().includes(lowerSearchTerm) ||
//         task.category?.toLowerCase().replace(/_/g, ' ').includes(lowerSearchTerm) ||
//         task.createdBy?.toLowerCase().includes(lowerSearchTerm) ||
//         commentsMatch
//     );
// };
// const nodeHasVisibleContent = (node, filters) => {
//     if (!node) return false;
//     if ((node.tasks || []).some(task => taskMatchesFilters(task, node, filters))) return true;
//     return (node.children || []).some(child => nodeHasVisibleContent(child, filters));
// };

// const useOutsideAlerter = (ref, callback) => { useEffect(() => { const handleClickOutside = (event) => { if (ref.current && !ref.current.contains(event.target)) { callback(); } }; document.addEventListener('mousedown', handleClickOutside); return () => document.removeEventListener('mousedown', handleClickOutside); }, [ref, callback]); };

// const UserProfileImage = ({ userName, className }) => (<div className={className}>{userName ? userName.charAt(0).toUpperCase() : ''}</div>);
// const TaskCardSkeleton = () => (<div className="task-card task-card-skeleton"><div className="task-content-area"><div className="task-card-header"><div className="shimmer-line shimmer-title"></div><div className="shimmer-block shimmer-badge"></div></div><div className="shimmer-line shimmer-desc"></div><div className="shimmer-line shimmer-desc-short"></div><div className="task-meta"><div className="shimmer-block shimmer-meta"></div><div className="shimmer-block shimmer-meta"></div></div></div></div>);

// const MultiSelectDropdown = ({ options, value, onChange, icon, defaultLabel }) => {
//     const [isOpen, setIsOpen] = useState(false);
//     const [searchTerm, setSearchTerm] = useState('');
//     const wrapperRef = useRef(null);
//     useEffect(() => { function handleClickOutside(event) { if (wrapperRef.current && !wrapperRef.current.contains(event.target)) { setIsOpen(false); setSearchTerm(''); } } document.addEventListener("mousedown", handleClickOutside); return () => document.removeEventListener("mousedown", handleClickOutside); }, [wrapperRef]);
//     const handleToggleOption = (optionValue) => { onChange(optionValue); };
//     const getTriggerLabel = () => { if (!value || value.length === 0) return defaultLabel; if (value.length === 1) { const selected = options.find(opt => opt.value === value[0]); return selected ? selected.label : (typeof value[0] === 'string' ? value[0].replace(/_/g, ' ') : ''); } return `${value.length} Selected`; };
//     const filteredOptions = options.filter(option => (option.label || '').toLowerCase().includes(searchTerm.toLowerCase()));
//     return (<div className="custom-select-wrapper" ref={wrapperRef} onMouseEnter={() => setIsOpen(true)} onMouseLeave={() => setIsOpen(false)}><div className="custom-select-trigger">{icon}<span>{getTriggerLabel()}</span><IoChevronDown className={`arrow ${isOpen ? 'open' : ''}`} /></div>{isOpen && (<div className="custom-options"><div className="custom-options-search"><IoSearchOutline /><input type="text" placeholder="Search..." value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} autoFocus onClick={e => e.stopPropagation()} /></div>{filteredOptions.length > 0 ? (filteredOptions.map(option => (<div key={option.value} className={`custom-option ${value.includes(option.value) ? 'selected' : ''}`} onClick={() => handleToggleOption(option.value)}><input type="checkbox" checked={value.includes(option.value)} readOnly /><label>{option.label}</label></div>))) : (<div className="custom-option-message">No results found</div>)}</div>)}</div>);
// };

// const SubtaskList = ({ parentTaskId, subtaskData, navigate, isSuperAdmin, onTaskDelete }) => {
//     const [expandedComments, setExpandedComments] = useState({});
//     const isVisible = subtaskData && subtaskData.isVisible;
//     if (!isVisible) return null;
//     if (subtaskData.isLoading) { return <div className="subtasks-professional-container"><div className="subtask-item-empty">Loading Subtasks...</div></div>; }
//     const handleToggleComment = (taskId) => { setExpandedComments(prev => ({ ...prev, [taskId]: !prev[taskId] })); };
//     const formatDate = (dateString) => { if (!dateString) return 'N/A'; return new Date(dateString).toLocaleDateString('en-GB', { day: '2-digit', month: 'short' }); };
//     return (<div className="subtasks-professional-container"><div className="subtask-professional-header"><span>Task</span><span>Assignee</span><span>Due Date</span><span>Priority</span><span>Status</span><span title="Latest Comment"><IoChatbubbleEllipsesOutline /></span><span>Actions</span></div><div className="subtask-professional-body">{subtaskData.tasks.length > 0 ? (subtaskData.tasks.map(subtask => { const latestCommentInfo = (() => { if (!subtask.comments || !Array.isArray(subtask.comments) || subtask.comments.length === 0) return null; const firstValidComment = subtask.comments.find(c => c && typeof c === 'string' && c.trim() !== '' && !c.includes('| reason :')); if (!firstValidComment) return null; const match = firstValidComment.match(/Comment by (.*?):/i); const author = match ? match[1] : 'System'; const text = firstValidComment.replace(/Comment by.*?:/i, '').trim(); return { author, text }; })(); const isCommentExpanded = !!expandedComments[subtask.taskId]; return (<div className="subtask-item-wrapper" key={subtask.taskId}><div className={`subtask-professional-row ${isCommentExpanded ? 'is-comment-expanded' : ''}`}><div className="subtask-cell-main-content" onClick={() => navigate(`/tasks/${subtask.taskId}`, { state: { task: subtask } })}><div className="subtask-cell-title"><span className="subtask-id">#{subtask.taskId}</span><span className="subtask-title">{subtask.title}</span></div><div className="subtask-cell-assignee"><UserProfileImage userName={subtask.assigneeName} className="user-avatar-subtask" /><span>{subtask.assigneeName || 'Unassigned'}</span></div><div className="subtask-cell-date"><IoCalendarOutline /><span>{formatDate(subtask.dueDate)}</span></div><div className="subtask-cell-priority">{subtask.priority && (<div className={`priority-badge priority-${subtask.priority.toLowerCase()}`}><IoFlagOutline /> {subtask.priority}</div>)}</div><div className="subtask-cell-status"><div className={`task-status-badge status-${getStatusClass(subtask.status)}`}>{subtask.status ? subtask.status.replace(/_/g, ' ') : 'None'}</div></div></div><div className="subtask-cell-comment" onClick={(e) => { e.stopPropagation(); if (latestCommentInfo) handleToggleComment(subtask.taskId); }}>{latestCommentInfo && <IoChatbubbleEllipsesOutline className="comment-indicator-icon" />}</div><div className="subtask-cell-actions">{isSuperAdmin && (<button onClick={(e) => { e.stopPropagation(); onTaskDelete(subtask.taskId, parentTaskId); }} className="action-btn delete-btn" title="Delete Subtask"><IoTrashOutline size={16} /></button>)}</div></div><div className={`subtask-comment-section ${isCommentExpanded ? 'visible' : ''}`}>{latestCommentInfo && (<><div className="comment-author">Latest Comment by {latestCommentInfo.author}</div><p className="comment-text">{latestCommentInfo.text}</p></>)}</div></div>); })) : (<div className="subtask-item-empty">No subtasks found for this task.</div>)}</div></div>);
// };

// const TaskCard = ({ item, isSuperAdmin, onTaskDelete, onCloneTask, onTaskSubtask, companyKeyword, onToggleSubtasks, subtaskData, index, viewMode, isTargetTask, isTagged }) => {
//     const { task, user } = item;
//     const navigate = useNavigate();
//     const cardRef = useRef(null);
//     const isSubtasksVisible = subtaskData && subtaskData.isVisible;

//     useEffect(() => {
//         if (isTargetTask && cardRef.current) {
//             cardRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
//             // Add a temporary highlight animation class manually if needed, or rely on 'highlighted' class prop 
//         }
//     }, [isTargetTask]);

//     const latestCommentInfo = useMemo(() => { if (!task.comments || !Array.isArray(task.comments) || task.comments.length === 0) return null; const firstValidComment = task.comments.find(c => c && typeof c === 'string' && c.trim() !== '' && !c.includes('| reason :')); if (!firstValidComment) return null; const match = firstValidComment.match(/Comment by (.*?):/i); const author = match ? match[1] : 'System'; const commentText = firstValidComment.replace(/Comment by.*?:/i, '').trim(); return { author, text: commentText }; }, [task.comments]);
//     const overdueInfo = useMemo(() => { if (task.status?.toLowerCase() === 'completed' || !task.dueDate) return null; if (task.remainingTime && task.remainingTime.includes('-')) { const cleanedTime = task.remainingTime.replace(/-/g, '').trim(); return { text: `Overdue by`, remainingTime: cleanedTime }; } const now = new Date(); const dueDate = new Date(task.dueDate); if (dueDate < now) return { text: 'Overdue', remainingTime: '' }; return null; }, [task.dueDate, task.status, task.remainingTime]);
//     const formatDateTime = (dateString) => { if (!dateString) return null; return new Date(dateString).toLocaleString('en-GB', { day: 'numeric', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit', hour12: false }).replace(',', ''); };
//     const createdDate = useMemo(() => formatDateTime(task.createdAt), [task.createdAt]);
//     const dueDate = useMemo(() => formatDateTime(task.dueDate), [task.dueDate]);
//     const completedDate = useMemo(() => task.status?.toLowerCase() === 'completed' ? formatDateTime(task.completedAt) : null, [task.status, task.completedAt]);
//     const renderDueDate = () => (<div className="meta-item-date"><IoCalendarOutline /> Due: {dueDate}{overdueInfo && (<span className="overdue-badge" style={{ marginLeft: '8px', padding: '2px 6px' }}><IoWarningOutline /> {overdueInfo.text} {overdueInfo.remainingTime}</span>)}</div>);
//     const cardClassName = `task-card-wrapper ${isTargetTask ? 'highlighted' : ''}`;
//     const taskCardClassName = `task-card ${isSubtasksVisible && viewMode !== 'grid' ? 'is-expanded' : ''} ${companyKeyword !== 'PL' && task.no_of_sub_tasks > 0 ? 'has-subtasks' : ''} ${isTagged ? 'is-tagged' : ''}`;

//     const completionHoverText = task.status?.toLowerCase() === 'completed' && task.completedAt
//         ? `Completed on: ${new Date(task.completedAt).toLocaleString('en-GB', { day: 'numeric', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' })}`
//         : task.status?.replace(/_/g, ' ');

//     if (viewMode === 'list') { return (<div className={cardClassName}><div className={taskCardClassName} style={{ animationDelay: `${index * 50}ms` }} ref={cardRef}><div className="task-content-area" onClick={() => navigate(`/tasks/${task.taskId}`, { state: { task } })}><div className="task-card-header"><h3 className="task-title">{task.title} <span className="task-id-badge">#{task.taskId}</span></h3>{task.status && <div className={`task-status-badge status-${getStatusClass(task.status)}`} title={completionHoverText}>{task.status.replace(/_/g, ' ')}</div>}</div><div className="task-project-customer-row">{task.projectName && <div className="task-project-badge"><IoBriefcaseOutline /> {task.projectName}</div>}{task.customerName && <div className="task-customer-badge"><IoBusinessOutline /> {task.customerName}</div>}</div><div className="task-card-footer"><div className="footer-meta-items">{task.priority && <div className={`priority-badge priority-${task.priority.toLowerCase()}`}><IoFlagOutline /> {task.priority}</div>}{companyKeyword !== 'PL' && task.no_of_sub_tasks > 0 && (<div className="meta-item-subtasks" title={`${task.no_of_sub_tasks} subtasks`}><IoGitNetworkOutline /> {task.no_of_sub_tasks}</div>)}{task.category && <div className="meta-item-category"><IoPricetagOutline /> {task.category.replace(/_/g, ' ')}</div>}{task.createdBy && <div className="meta-item-date"><IoPeopleOutline /> Created By: {task.createdBy}</div>}{createdDate && <div className="meta-item-date"><IoCalendarOutline /> Created: {createdDate}</div>}{dueDate && renderDueDate()}{completedDate && <div className="meta-item-date completed"><IoCheckmarkDoneCircleOutline /> Completed: {completedDate}</div>}</div>{latestCommentInfo && (<div className="comment-indicator" title="Latest Comment"><IoChatbubbleEllipsesOutline /></div>)}</div></div>{latestCommentInfo && (<div className="comment-section"><div className="comment-author">Latest Comment by {latestCommentInfo.author}</div><p className="comment-text">{latestCommentInfo.text}</p></div>)}<div className="grid-card-user-info">{companyKeyword === 'ZO' && !task.parentTaskId && (<button onClick={() => onToggleSubtasks(task.taskId)} className="action-btn subtask-toggle-btn" title="View Subtasks"><IoChevronDown style={{ transform: isSubtasksVisible ? 'rotate(180deg)' : 'rotate(0deg)' }} /></button>)}<UserProfileImage userName={user.name} className="user-avatar-small" /><span className="user-name-small">{user.name}</span><div className="task-actions">{companyKeyword === 'ZO' && !task.parentTaskId && (<button onClick={(e) => { e.stopPropagation(); onTaskSubtask(task); }} className="action-btn subtask-btn" title="Create Subtask"><IoGitNetworkOutline size={16} /></button>)}<button onClick={(e) => { e.stopPropagation(); onCloneTask(task); }} className="action-btn clone-btn" title="Clone Task"><IoCopyOutline size={16} /></button>{isSuperAdmin && (<button onClick={(e) => { e.stopPropagation(); onTaskDelete(task.taskId); }} className="action-btn delete-btn" title="Delete Task"><IoTrashOutline size={16} /></button>)}</div></div></div>{companyKeyword !== 'PL' && <SubtaskList parentTaskId={task.taskId} subtaskData={subtaskData} navigate={navigate} isSuperAdmin={isSuperAdmin} onTaskDelete={onTaskDelete} />}</div>); }
//     return (<div className={cardClassName}><div className={taskCardClassName} style={{ animationDelay: `${index * 50}ms` }} ref={cardRef}><div className="task-content-area" onClick={() => navigate(`/tasks/${task.taskId}`, { state: { task } })}><div className="task-card-header"><h3 className="task-title">{task.title} <span className="task-id-badge">#{task.taskId}</span></h3>{task.status && <div className={`task-status-badge status-${getStatusClass(task.status)}`} title={completionHoverText}>{task.status.replace(/_/g, ' ')}</div>}</div><div className="task-project-customer-row">{task.projectName && <div className="task-project-badge"><IoBriefcaseOutline /> {task.projectName}</div>}{task.customerName && <div className="task-customer-badge"><IoBusinessOutline /> {task.customerName}</div>}</div>{task.description && <p className="task-description">{task.description}</p>}<div className="task-card-footer"><div className="footer-meta-items">{task.priority && <div className={`priority-badge priority-${task.priority.toLowerCase()}`}><IoFlagOutline /> {task.priority}</div>}{companyKeyword !== 'PL' && task.no_of_sub_tasks > 0 && (<div className="meta-item-subtasks" title={`${task.no_of_sub_tasks} subtasks`}><IoGitNetworkOutline /> {task.no_of_sub_tasks}</div>)}{task.category && <div className="meta-item-category"><IoPricetagOutline /> {task.category.replace(/_/g, ' ')}</div>}{task.createdBy && <div className="meta-item-date"><IoPeopleOutline /> Created By: {task.createdBy}</div>}{createdDate && <div className="meta-item-date"><IoCalendarOutline /> Created: {createdDate}</div>}{dueDate && renderDueDate()}{completedDate && <div className="meta-item-date completed"><IoCheckmarkDoneCircleOutline /> Completed: {completedDate}</div>}</div>{latestCommentInfo && (<div className="comment-indicator" title="Latest Comment"><IoChatbubbleEllipsesOutline /></div>)}</div></div>{latestCommentInfo && (<div className="comment-section"><div className="comment-author">Latest Comment by {latestCommentInfo.author}</div><p className="comment-text">{latestCommentInfo.text}</p></div>)}<div className="grid-card-user-info">{companyKeyword === 'ZO' && !task.parentTaskId && viewMode !== 'grid' && (<button onClick={() => onToggleSubtasks(task.taskId)} className="action-btn subtask-toggle-btn" title="View Subtasks"><IoChevronDown style={{ transform: isSubtasksVisible ? 'rotate(180deg)' : 'rotate(0deg)' }} /></button>)}<UserProfileImage userName={user.name} className="user-avatar-small" /><span className="user-name-small">{user.name}</span><div className="task-actions">{companyKeyword === 'ZO' && !task.parentTaskId && (<button onClick={(e) => { e.stopPropagation(); onTaskSubtask(task); }} className="action-btn subtask-btn" title="Create Subtask"><IoGitNetworkOutline size={16} /></button>)}<button onClick={(e) => { e.stopPropagation(); onCloneTask(task); }} className="action-btn clone-btn" title="Clone Task"><IoCopyOutline size={16} /></button>{isSuperAdmin && (<button onClick={(e) => { e.stopPropagation(); onTaskDelete(task.taskId); }} className="action-btn delete-btn" title="Delete Task"><IoTrashOutline size={16} /></button>)}</div></div></div>{companyKeyword !== 'PL' && viewMode !== 'grid' && <SubtaskList parentTaskId={task.taskId} subtaskData={subtaskData} navigate={navigate} isSuperAdmin={isSuperAdmin} onTaskDelete={onTaskDelete} />}</div>);
// };

// const TaskCompactListItem = ({ item, isSuperAdmin, onTaskDelete, onCloneTask, onTaskSubtask, companyKeyword, index, isTargetTask, onToggleSubtasks, subtaskData, navigate, isTagged }) => {
//     const { task, user } = item;
//     const itemRef = useRef(null);
//     const isSubtasksVisible = subtaskData && subtaskData.isVisible;

//     useEffect(() => {
//         if (isTargetTask && itemRef.current) {
//             itemRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
//         }
//     }, [isTargetTask]);

//     const formatDate = (dateString) => { if (!dateString) return null; return new Date(dateString).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' }); };
//     const dueDate = formatDate(task.dueDate);
//     const itemClassName = `task-compact-list-item ${isTargetTask ? 'highlighted' : ''} ${isSubtasksVisible ? 'is-expanded' : ''} ${companyKeyword !== 'PL' && task.no_of_sub_tasks > 0 ? 'has-subtasks' : ''} ${isTagged ? 'is-tagged' : ''}`;
//     const handleNavigate = () => { navigate(`/tasks/${task.taskId}`); };

//     const completionHoverText = task.status?.toLowerCase() === 'completed' && task.completedAt
//         ? `Completed on: ${new Date(task.completedAt).toLocaleString('en-GB', { day: 'numeric', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' })}`
//         : task.status?.replace(/_/g, ' ');

//     return (<div className={itemClassName} style={{ animationDelay: `${index * 30}ms` }} ref={itemRef} onClick={handleNavigate}><div className="task-compact-list-id-section">#{task.taskId}</div><div className="task-compact-list-title-section"><span className="task-title">{task.title}</span></div><div className="task-compact-list-project-section">{task.projectName && (<div className="meta-badge project-badge" title={task.projectName}><IoBriefcaseOutline /><span>{task.projectName}</span></div>)}</div><div className="task-compact-list-customer-section">{task.customerName && (<div className="meta-badge customer-badge" title={task.customerName}><IoBusinessOutline /><span>{task.customerName}</span></div>)}</div>{companyKeyword !== 'PL' && (<div className="task-compact-list-subtask-section">{task.no_of_sub_tasks > 0 && (<div className="meta-badge subtask-badge" title={`${task.no_of_sub_tasks} subtasks`}><IoGitNetworkOutline /><span>{task.no_of_sub_tasks}</span></div>)}</div>)}<div className="task-compact-list-category-section">{task.category && (<div className="meta-badge category-badge" title={task.category.replace(/_/g, ' ')}><IoPricetagOutline /><span>{task.category.replace(/_/g, ' ')}</span></div>)}</div><div className="task-compact-list-priority-section">{task.priority && (<div className={`meta-badge priority-badge priority-${task.priority.toLowerCase()}`}><IoFlagOutline /><span>{task.priority}</span></div>)}</div><div className="task-compact-list-status-section">{task.status && (<div className={`meta-badge status-badge status-${getStatusClass(task.status)}`} title={completionHoverText}><span>{task.status.replace(/_/g, ' ')}</span></div>)}</div><div className="task-compact-list-date-section">{dueDate && (<div className="meta-badge date-badge"><IoCalendarOutline /><span>{dueDate}</span></div>)}</div><div className="task-compact-list-user-section"><UserProfileImage userName={user.name} className="user-avatar-small" /><span className="user-name" title={user.name}>{user.name}</span></div><div className="task-compact-list-actions">{companyKeyword === 'ZO' && !task.parentTaskId && (<button onClick={(e) => { e.stopPropagation(); onToggleSubtasks(task.taskId); }} className="action-btn subtask-toggle-btn" title="View Subtasks"><IoChevronDown style={{ transform: isSubtasksVisible ? 'rotate(180deg)' : 'rotate(0deg)' }} /></button>)}{companyKeyword === 'ZO' && !task.parentTaskId && (<button onClick={(e) => { e.stopPropagation(); onTaskSubtask(task); }} className="action-btn subtask-btn" title="Create Subtask"><IoGitNetworkOutline size={16} /></button>)}<button onClick={(e) => { e.stopPropagation(); onCloneTask(task); }} className="action-btn clone-btn" title="Clone Task"><IoCopyOutline size={16} /></button>{isSuperAdmin && (<button onClick={(e) => { e.stopPropagation(); onTaskDelete(task.taskId); }} className="action-btn delete-btn" title="Delete Task"><IoTrashOutline size={16} /></button>)}</div></div>);
// };

// const UserNode = ({ node, isSuperAdmin, onTaskDelete, onCloneTask, onTaskSubtask, companyKeyword, onToggleSubtasks, expandedSubtasks, depth = 0, targetTaskId, filters, taggedTaskIds }) => {
//     const isInitiallyExpanded = useMemo(() => { if (targetTaskId && (node.tasks || []).some(t => String(t.taskId) === String(targetTaskId))) return true; return false; }, [node.tasks, targetTaskId]);
//     const [isExpanded, setIsExpanded] = useState(isInitiallyExpanded);
//     const taskRefs = useRef({});
//     useEffect(() => { setIsExpanded(isInitiallyExpanded); }, [isInitiallyExpanded]);

//     useEffect(() => {
//         if (targetTaskId && isExpanded && taskRefs.current[targetTaskId]) {
//             taskRefs.current[targetTaskId].scrollIntoView({ behavior: 'smooth', block: 'center' });
//         }
//     }, [isExpanded, targetTaskId]);

//     const filteredTasks = useMemo(() => (node.tasks || []).filter(task => taskMatchesFilters(task, node, filters)).sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt)), [node, filters]);
//     const hasTasks = filteredTasks.length > 0;
//     const hasVisibleChildren = (node.children || []).some(child => nodeHasVisibleContent(child, filters));
//     const handleToggle = () => { if (hasTasks) setIsExpanded(!isExpanded); };
//     if (!hasTasks && !hasVisibleChildren) { return null; }
//     return (<div className="user-node" style={{ paddingLeft: `${depth * 25}px` }}><div className="user-header" onClick={handleToggle} style={{ cursor: hasTasks ? 'pointer' : 'default' }}><span className="user-node-toggle-icon">{hasTasks ? (<IoChevronDown style={{ transform: isExpanded ? 'rotate(0deg)' : 'rotate(-90deg)', transition: 'transform 0.2s' }} />) : (<span style={{ width: '1.25rem', display: 'inline-block' }}></span>)}</span><UserProfileImage userName={node.name} className="user-avatar" /><div><div className="user-name">{node.name}</div><div className="user-designation">{node.designation || 'N/A'}</div></div></div>{isExpanded && hasTasks && (<div className="node-body"><div className="tasks-list-view-container">{filteredTasks.map((task, taskIndex) => (<div key={task.taskId} ref={(el) => (taskRefs.current[task.taskId] = el)}><TaskCard item={{ task, user: node }} isSuperAdmin={isSuperAdmin} onTaskDelete={onTaskDelete} onCloneTask={onCloneTask} onTaskSubtask={onTaskSubtask} companyKeyword={companyKeyword} onToggleSubtasks={onToggleSubtasks} subtaskData={expandedSubtasks[task.taskId]} index={taskIndex} viewMode="list" isTargetTask={targetTaskId && String(task.taskId) === String(targetTaskId)} isTagged={taggedTaskIds.has(task.taskId)} /></div>))}</div></div>)}{hasVisibleChildren && (<div className="children-nodes">{node.children.map(child => (<UserNode key={child.id} node={child} isSuperAdmin={isSuperAdmin} onTaskDelete={onTaskDelete} onCloneTask={onCloneTask} onTaskSubtask={onTaskSubtask} companyKeyword={companyKeyword} onToggleSubtasks={onToggleSubtasks} expandedSubtasks={expandedSubtasks} depth={depth + 1} targetTaskId={targetTaskId} filters={filters} taggedTaskIds={taggedTaskIds} />))}</div>)}</div>);
// };

// const Modal = ({ isOpen, onClose, title, children }) => { const modalRef = useRef(); useOutsideAlerter(modalRef, onClose); if (!isOpen) return null; return (<div className="template-modal-overlay"><div className="template-modal" ref={modalRef}><div className="template-modal-header"><h3>{title}</h3><button onClick={onClose} className="close-modal-btn"><IoClose /></button></div><div className="template-modal-body">{children}</div></div></div>); };

// const ConfirmationModal = ({ isOpen, onClose, onConfirm, title, children }) => {
//     const modalRef = useRef();
//     useOutsideAlerter(modalRef, onClose);
//     if (!isOpen) return null;
//     return (
//         <div className="confirmation-modal-overlay">
//             <div className="confirmation-modal" ref={modalRef}>
//                 <div className="confirmation-modal-header">
//                     <h3>{title}</h3>
//                     <button onClick={onClose} className="close-modal-btn"><IoClose /></button>
//                 </div>
//                 <div className="confirmation-modal-body">
//                     {children}
//                 </div>
//                 <div className="confirmation-modal-footer">
//                     <button onClick={onClose} className="confirm-btn cancel">Cancel</button>
//                     <button onClick={onConfirm} className="confirm-btn confirm">Delete</button>
//                 </div>
//             </div>
//         </div>
//     );
// };

// const AssignDraftModal = ({ isOpen, onClose, onConfirm, users, title }) => {
//     const modalRef = useRef();
//     const [selectedUserId, setSelectedUserId] = useState(null);
//     const [searchTerm, setSearchTerm] = useState('');

//     useOutsideAlerter(modalRef, onClose);

//     useEffect(() => {
//         if (isOpen) {
//             setSelectedUserId(null);
//             setSearchTerm('');
//         }
//     }, [isOpen]);

//     const filteredUsers = useMemo(() => {
//         if (!searchTerm) return users;
//         const lowercasedFilter = searchTerm.toLowerCase();
//         return users.filter(user =>
//             user.name.toLowerCase().includes(lowercasedFilter)
//         );
//     }, [users, searchTerm]);

//     const handleConfirm = () => {
//         if (selectedUserId) {
//             onConfirm(selectedUserId);
//         }
//     };

//     if (!isOpen) return null;

//     return (
//         <div className="confirmation-modal-overlay assign-modal">
//             <div className="confirmation-modal" ref={modalRef} style={{ minWidth: '400px' }}>
//                 <div className="confirmation-modal-header">
//                     <h3>{title}</h3>
//                     <button onClick={onClose} className="close-modal-btn"><IoClose /></button>
//                 </div>
//                 <div className="confirmation-modal-body">
//                     <div className="template-modal-search" style={{ marginBottom: '15px', padding: '0' }}>
//                         <IoSearchOutline />
//                         <input
//                             type="text"
//                             placeholder="Search user..."
//                             value={searchTerm}
//                             onChange={(e) => setSearchTerm(e.target.value)}
//                             autoFocus
//                         />
//                     </div>
//                     <div className="user-selection-list">
//                         {filteredUsers.length > 0 ? filteredUsers.map(user => (
//                             <div
//                                 key={user.id}
//                                 className={`user-selection-item ${selectedUserId === user.id ? 'selected' : ''}`}
//                                 onClick={() => setSelectedUserId(user.id)}
//                             >
//                                 <UserProfileImage userName={user.name} className="user-avatar-small" />
//                                 <span className="user-name-small">{user.name}</span>
//                             </div>
//                         )) : <div className="no-results-message">No users found.</div>}
//                     </div>
//                 </div>
//                 <div className="confirmation-modal-footer">
//                     <button onClick={onClose} className="confirm-btn cancel">Cancel</button>
//                     <button onClick={handleConfirm} className="confirm-btn confirm" disabled={!selectedUserId}>Assign</button>
//                 </div>
//             </div>
//         </div>
//     );
// };

// const TemplatePreviewModal = ({ isOpen, onClose, template }) => {
//     const modalRef = useRef();
//     const [expandedMainTasks, setExpandedMainTasks] = useState(new Set());

//     useOutsideAlerter(modalRef, onClose);

//     useEffect(() => {
//         setExpandedMainTasks(new Set());
//     }, [template]);

//     const toggleMainTask = (mainTaskId) => {
//         setExpandedMainTasks(prev => {
//             const newSet = new Set(prev);
//             if (newSet.has(mainTaskId)) {
//                 newSet.delete(mainTaskId);
//             } else {
//                 newSet.add(mainTaskId);
//             }
//             return newSet;
//         });
//     };

//     if (!isOpen || !template) return null;

//     return (
//         <div className="preview-modal-overlay">
//             <div className="preview-modal" ref={modalRef}>
//                 <div className="template-modal-header">
//                     <h3><IoDocumentsOutline /> Preview: {template.projectTemplateName}</h3>
//                     <button onClick={onClose} className="close-modal-btn"><IoClose /></button>
//                 </div>
//                 <div className="template-preview-body">
//                     {template.mainTasks && template.mainTasks.length > 0 ? (
//                         <ul className="main-task-list">
//                             {template.mainTasks.map(mainTask => {
//                                 const hasSubtasks = mainTask.subTasks && mainTask.subTasks.length > 0;
//                                 const isExpanded = expandedMainTasks.has(mainTask.mainTaskId);
//                                 return (
//                                     <li key={mainTask.mainTaskId} className={`main-task-item ${hasSubtasks ? 'has-subtasks' : ''}`}>
//                                         <div className="main-task-title" onClick={() => hasSubtasks && toggleMainTask(mainTask.mainTaskId)}>
//                                             <IoGitNetworkOutline className="main-task-icon" />
//                                             <span>{mainTask.mainTaskTitle}</span>
//                                             {hasSubtasks && <IoChevronDown className={`main-task-chevron ${isExpanded ? 'expanded' : ''}`} />}
//                                         </div>
//                                         {hasSubtasks && (
//                                             <div className={`sub-task-container ${isExpanded ? 'expanded' : ''}`}>
//                                                 <ul className="sub-task-list">
//                                                     {mainTask.subTasks.map(subTask => (
//                                                         <li key={subTask.subTaskId} className="sub-task-item">
//                                                             <IoReturnDownForwardOutline className="sub-task-icon" />
//                                                             <span>{subTask.subTaskTitle}</span>
//                                                         </li>
//                                                     ))}
//                                                 </ul>
//                                             </div>
//                                         )}
//                                     </li>
//                                 );
//                             })}
//                         </ul>
//                     ) : (
//                         <div className="template-option-message empty">
//                             <IoDocumentsOutline />
//                             <span>This template has no tasks defined yet.</span>
//                         </div>
//                     )}
//                 </div>
//                 <div className="template-modal-footer">
//                     <button onClick={onClose} className="close-preview-btn">Close</button>
//                 </div>
//             </div>
//         </div>
//     );
// };


// const TasksListPage = () => {
//     const location = useLocation();
//     const navigate = useNavigate();

//     const [isInitialising, setIsInitialising] = useState(true);
//     const [isTasksLoading, setIsTasksLoading] = useState(false);
//     const [isLoadingMore, setIsLoadingMore] = useState(false);
//     const [hasMore, setHasMore] = useState(true);
//     const [currentPage, setCurrentPage] = useState(1);
//     const [error, setError] = useState(null);
//     const [infoMessage, setInfoMessage] = useState(null);

//     const [allScopedTasks, setAllScopedTasks] = useState([]);
//     const [fullHierarchy, setFullHierarchy] = useState([]);
//     const [allUsers, setAllUsers] = useState([]);
//     const [isSuperAdmin, setIsSuperAdmin] = useState(false);
//     const [isReportingManager, setIsReportingManager] = useState(false);
//     const [companyKeyword, setCompanyKeyword] = useState('');
//     const [taggedTaskIds, setTaggedTaskIds] = useState(new Set());
//     const [subordinateUsers, setSubordinateUsers] = useState([]);

//     const [viewMode, setViewMode] = useState('compact-list');
//     const [searchTerm, setSearchTerm] = useState('');
//     const debouncedSearchTerm = useDebounce(searchTerm, 300);

//     const [expandedSubtasks, setExpandedSubtasks] = useState({});
//     const [targetTaskId, setTargetTaskId] = useState(null);

//     const [filterTaskId, setFilterTaskId] = useState(null);
//     const [filterStatus, setFilterStatus] = useState([]);
//     const [filterPriority, setFilterPriority] = useState([]);
//     const [filterProjectName, setFilterProjectName] = useState([]);
//     const [filterCategory, setFilterCategory] = useState([]);
//     const [filterUserId, setFilterUserId] = useState([]);
//     const [filterYear, setFilterYear] = useState([]);
//     const [filterMonth, setFilterMonth] = useState([]);
//     const [filterDepartment, setFilterDepartment] = useState([]);
//     const [filterVendorTypes, setFilterVendorTypes] = useState([]);
//     const [filterCustomers, setFilterCustomers] = useState([]);
//     const [filterSuppliers, setFilterSuppliers] = useState([]);

//     const [dateFilterType, setDateFilterType] = useState('none');
//     const [dateFrom, setDateFrom] = useState('');
//     const [dateTo, setDateTo] = useState('');
//     const [fromDay, setFromDay] = useState(currentDay.toString());
//     const [fromMonth, setFromMonth] = useState(currentMonth.toString());
//     const [fromYear, setFromYear] = useState(currentYear.toString());
//     const [toDay, setToDay] = useState(currentDay.toString());
//     const [toMonth, setToMonth] = useState(currentMonth.toString());
//     const [toYear, setToYear] = useState(currentYear.toString());
//     const [daysInFromMonth, setDaysInFromMonth] = useState([]);
//     const [daysInToMonth, setDaysInToMonth] = useState([]);

//     const [masterVendorTypes, setMasterVendorTypes] = useState([]);
//     const [masterCustomers, setMasterCustomers] = useState([]);
//     const [masterSuppliers, setMasterSuppliers] = useState([]);

//     const [projectTemplates, setProjectTemplates] = useState([]);
//     const [isTemplateSelectionModalOpen, setIsTemplateSelectionModalOpen] = useState(false);
//     const [templateError, setTemplateError] = useState(null);
//     const [isDraftSelectionModalOpen, setIsDraftSelectionModalOpen] = useState(false);
//     const [isCheckingForDrafts, setIsCheckingForDrafts] = useState(false);

//     const [groupedDrafts, setGroupedDrafts] = useState([]);
//     const [expandedTemplateId, setExpandedTemplateId] = useState(null);

//     const [isDraftDeleteConfirmOpen, setIsDraftDeleteConfirmOpen] = useState(false);
//     const [draftToDelete, setDraftToDelete] = useState(null);

//     const [isAssignDraftModalOpen, setIsAssignDraftModalOpen] = useState(false);
//     const [draftToAssign, setDraftToAssign] = useState(null);

//     const [modalSearchTerm, setModalSearchTerm] = useState('');

//     const [isPreviewModalOpen, setIsPreviewModalOpen] = useState(false);
//     const [templateToPreview, setTemplateToPreview] = useState(null);

//     const handleOpenPreviewModal = (template) => {
//         setTemplateToPreview(template);
//         setIsPreviewModalOpen(true);
//     };

//     const handleClosePreviewModal = () => {
//         setIsPreviewModalOpen(false);
//         setTemplateToPreview(null);
//     };

//     const handleResetFilters = useCallback(() => {
//         setSearchTerm('');
//         setFilterStatus([]);
//         setFilterPriority([]);
//         setFilterProjectName([]);
//         setFilterCategory([]);
//         setFilterYear([]);
//         setFilterMonth([]);
//         setFilterDepartment([]);
//         setFilterVendorTypes([]);
//         setFilterCustomers([]);
//         setFilterSuppliers([]);
//         setDateFilterType('none');
//         setTargetTaskId(null);
//         setFilterUserId([]);
//         setFilterTaskId(null);
//         setFromDay(currentDay.toString());
//         setFromMonth(currentMonth.toString());
//         setFromYear(currentYear.toString());
//         setToDay(currentDay.toString());
//         setToMonth(currentMonth.toString());
//         setToYear(currentYear.toString());
//         setDateFrom('');
//         setDateTo('');
//         // Clear session storage
//         sessionStorage.removeItem(SESSION_STORAGE_KEY);
//     }, []);

//     // --- SAVE FILTER STATE TO SESSION STORAGE ---
//     useEffect(() => {
//         const filterState = {
//             searchTerm,
//             filterStatus,
//             filterPriority,
//             filterProjectName,
//             filterCategory,
//             filterUserId,
//             filterYear,
//             filterMonth,
//             filterDepartment,
//             filterVendorTypes,
//             filterCustomers,
//             filterSuppliers,
//             dateFilterType,
//             dateFrom,
//             dateTo,
//             fromDay,
//             fromMonth,
//             fromYear,
//             toDay,
//             toMonth,
//             toYear,
//             viewMode
//         };
//         sessionStorage.setItem(SESSION_STORAGE_KEY, JSON.stringify(filterState));
//     }, [searchTerm, filterStatus, filterPriority, filterProjectName, filterCategory, filterUserId,
//         filterYear, filterMonth, filterDepartment, filterVendorTypes, filterCustomers, filterSuppliers,
//         dateFilterType, dateFrom, dateTo, fromDay, fromMonth, fromYear, toDay, toMonth, toYear, viewMode]);

//     // --- RESTORE FILTER STATE FROM SESSION STORAGE ON MOUNT ---
//     useEffect(() => {
//         try {
//             const savedState = sessionStorage.getItem(SESSION_STORAGE_KEY);
//             if (savedState) {
//                 const parsedState = JSON.parse(savedState);
//                 // Restore all filter states
//                 if (parsedState.searchTerm !== undefined) setSearchTerm(parsedState.searchTerm);
//                 if (parsedState.filterStatus) setFilterStatus(parsedState.filterStatus);
//                 if (parsedState.filterPriority) setFilterPriority(parsedState.filterPriority);
//                 if (parsedState.filterProjectName) setFilterProjectName(parsedState.filterProjectName);
//                 if (parsedState.filterCategory) setFilterCategory(parsedState.filterCategory);
//                 if (parsedState.filterUserId) setFilterUserId(parsedState.filterUserId);
//                 if (parsedState.filterYear) setFilterYear(parsedState.filterYear);
//                 if (parsedState.filterMonth) setFilterMonth(parsedState.filterMonth);
//                 if (parsedState.filterDepartment) setFilterDepartment(parsedState.filterDepartment);
//                 if (parsedState.filterVendorTypes) setFilterVendorTypes(parsedState.filterVendorTypes);
//                 if (parsedState.filterCustomers) setFilterCustomers(parsedState.filterCustomers);
//                 if (parsedState.filterSuppliers) setFilterSuppliers(parsedState.filterSuppliers);
//                 if (parsedState.dateFilterType) setDateFilterType(parsedState.dateFilterType);
//                 if (parsedState.dateFrom) setDateFrom(parsedState.dateFrom);
//                 if (parsedState.dateTo) setDateTo(parsedState.dateTo);
//                 if (parsedState.fromDay) setFromDay(parsedState.fromDay);
//                 if (parsedState.fromMonth) setFromMonth(parsedState.fromMonth);
//                 if (parsedState.fromYear) setFromYear(parsedState.fromYear);
//                 if (parsedState.toDay) setToDay(parsedState.toDay);
//                 if (parsedState.toMonth) setToMonth(parsedState.toMonth);
//                 if (parsedState.toYear) setToYear(parsedState.toYear);
//                 if (parsedState.viewMode) setViewMode(parsedState.viewMode);
//             }
//         } catch (error) {
//             console.error('Error restoring filter state:', error);
//         }
//     }, []); // Run only once on mount

//     // --- EFFECT TO HANDLE REDIRECTION FILTERS FROM DASHBOARD & RETURN FROM DETAILS ---
//     useEffect(() => {
//         const state = location.state || {};
//         const { initialFilter, targetTaskId: returnedTaskId } = state;

//         if (initialFilter) {
//             handleResetFilters();

//             if (initialFilter.taskId) {
//                 setFilterTaskId(String(initialFilter.taskId));
//                 setTargetTaskId(String(initialFilter.taskId));
//             }

//             if (initialFilter.userId) {
//                 if (Array.isArray(initialFilter.userId)) {
//                     setFilterUserId(initialFilter.userId.map(String));
//                 } else {
//                     setFilterUserId([String(initialFilter.userId)]);
//                 }
//             }

//             if (initialFilter.status) {
//                 if (Array.isArray(initialFilter.status)) {
//                     setFilterStatus(initialFilter.status.map(normalizeForComparison));
//                 } else {
//                     setFilterStatus([normalizeForComparison(initialFilter.status)]);
//                 }
//             }
//             if (initialFilter.priority) {
//                 if (Array.isArray(initialFilter.priority)) {
//                     setFilterPriority(initialFilter.priority.map(normalizeForComparison));
//                 } else {
//                     setFilterPriority([normalizeForComparison(initialFilter.priority)]);
//                 }
//             }
//             if (initialFilter.projectName) {
//                 if (Array.isArray(initialFilter.projectName)) {
//                     setFilterProjectName(initialFilter.projectName.map(normalizeForComparison));
//                 } else {
//                     setFilterProjectName([normalizeForComparison(initialFilter.projectName)]);
//                 }
//             }
//             if (initialFilter.category) {
//                 if (Array.isArray(initialFilter.category)) {
//                     setFilterCategory(initialFilter.category.map(normalizeForComparison));
//                 } else {
//                     setFilterCategory([normalizeForComparison(initialFilter.category)]);
//                 }
//             }
//             if (initialFilter.department) {
//                 if (Array.isArray(initialFilter.department)) {
//                     setFilterDepartment(initialFilter.department);
//                 } else {
//                     setFilterDepartment([normalizeForComparison(initialFilter.department)]);
//                 }
//             }
//             if (initialFilter.vendorTypes) {
//                 if (Array.isArray(initialFilter.vendorTypes)) {
//                     setFilterVendorTypes(initialFilter.vendorTypes.map(String));
//                 } else {
//                     setFilterVendorTypes([String(initialFilter.vendorTypes)]);
//                 }
//             }
//             if (initialFilter.customers) {
//                 if (Array.isArray(initialFilter.customers)) {
//                     setFilterCustomers(initialFilter.customers.map(String));
//                 } else {
//                     setFilterCustomers([String(initialFilter.customers)]);
//                 }
//             }
//             if (initialFilter.suppliers) {
//                 if (Array.isArray(initialFilter.suppliers)) {
//                     setFilterSuppliers(initialFilter.suppliers.map(String));
//                 } else {
//                     setFilterSuppliers([String(initialFilter.suppliers)]);
//                 }
//             }
//             if (initialFilter.year) {
//                 if (Array.isArray(initialFilter.year)) {
//                     setFilterYear(initialFilter.year.map(String));
//                 } else {
//                     setFilterYear([String(initialFilter.year)]);
//                 }
//             }
//             if (initialFilter.month) {
//                 if (Array.isArray(initialFilter.month)) {
//                     setFilterMonth(initialFilter.month.map(String));
//                 } else {
//                     setFilterMonth([String(initialFilter.month)]);
//                 }
//             }

//             navigate(location.pathname, { replace: true, state: {} });
//         } else if (returnedTaskId) {
//             // Returning from task detail page - filters are already restored from session storage via the save effect
//             setTargetTaskId(String(returnedTaskId));
//             navigate(location.pathname, { replace: true, state: {} });
//         }
//     }, [location.state, navigate, handleResetFilters]);

//     useEffect(() => {
//         if (filterTaskId) {
//             if (debouncedSearchTerm || filterStatus.length || filterPriority.length || filterProjectName.length || filterCategory.length || filterUserId.length || filterYear.length || filterMonth.length || filterDepartment.length || filterVendorTypes.length || filterCustomers.length || filterSuppliers.length || dateFilterType !== 'none') {
//                 setFilterTaskId(null);
//             }
//         }
//     }, [debouncedSearchTerm, filterStatus, filterPriority, filterProjectName, filterCategory, filterUserId, filterYear, filterMonth, filterDepartment, filterVendorTypes, filterCustomers, filterSuppliers, dateFilterType, filterTaskId]);

//     const fetchTasksByPage = useCallback(async (page, userIds) => { if (!userIds || userIds.length === 0) return []; const taskPromises = userIds.map(id => getTasksByUserIdAPI(id, page, TASKS_PER_PAGE)); const tasksForAllUsers = await Promise.all(taskPromises); return tasksForAllUsers.flat(); }, []);

//     const filters = useMemo(() => ({ taskId: filterTaskId, searchTerm: debouncedSearchTerm, status: filterStatus, priority: filterPriority, projectName: filterProjectName, userId: filterUserId, category: filterCategory, year: filterYear, month: filterMonth, dateFilterType, dateFrom, dateTo, department: filterDepartment, vendorTypes: filterVendorTypes, customers: filterCustomers, suppliers: filterSuppliers }), [filterTaskId, debouncedSearchTerm, filterStatus, filterPriority, filterProjectName, filterUserId, filterCategory, filterYear, filterMonth, dateFilterType, dateFrom, dateTo, filterDepartment, filterVendorTypes, filterCustomers, filterSuppliers]);

//     useEffect(() => { const maxDays = getDaysInMonth(fromYear, fromMonth); setDaysInFromMonth(Array.from({ length: maxDays }, (_, i) => (i + 1).toString())); if (parseInt(fromDay, 10) > maxDays) { setFromDay(maxDays.toString()); } }, [fromYear, fromMonth, fromDay]);
//     useEffect(() => { const maxDays = getDaysInMonth(toYear, toMonth); setDaysInToMonth(Array.from({ length: maxDays }, (_, i) => (i + 1).toString())); if (parseInt(toDay, 10) > maxDays) { setToDay(maxDays.toString()); } }, [toYear, toMonth, toDay]);
//     useEffect(() => { if (dateFilterType !== 'none') { setToDay(fromDay); setToMonth(fromMonth); setToYear(fromYear); } }, [fromDay, fromMonth, fromYear, dateFilterType]);
//     useEffect(() => { if (dateFilterType !== 'none') { setDateFrom(`${fromYear}-${pad(fromMonth)}-${pad(fromDay)}`); setDateTo(`${toYear}-${pad(toMonth)}-${pad(toDay)}`); } else { setDateFrom(''); setDateTo(''); } }, [fromDay, fromMonth, fromYear, toDay, toMonth, toYear, dateFilterType]);

//     const handleMultiSelectChange = (setter) => (value) => { setter(prev => { const newValues = new Set(prev); if (newValues.has(value)) { newValues.delete(value); } else { newValues.add(value); } return [...newValues]; }); };
//     const handleSearchChange = (e) => setSearchTerm(e.target.value);
//     const handleStatusChange = handleMultiSelectChange(setFilterStatus);
//     const handlePriorityChange = handleMultiSelectChange(setFilterPriority);
//     const handleProjectChange = handleMultiSelectChange(setFilterProjectName);
//     const handleCategoryChange = handleMultiSelectChange(setFilterCategory);
//     const handleUserChange = handleMultiSelectChange(setFilterUserId);
//     const handleYearChange = handleMultiSelectChange(setFilterYear);
//     const handleMonthChange = handleMultiSelectChange(setFilterMonth);
//     const handleDepartmentChange = handleMultiSelectChange(setFilterDepartment);
//     const handleDateTypeChange = (e) => setDateFilterType(e.target.value);
//     const handleVendorTypesChange = handleMultiSelectChange(setFilterVendorTypes);
//     const handleCustomersChange = handleMultiSelectChange(setFilterCustomers);
//     const handleSuppliersChange = handleMultiSelectChange(setFilterSuppliers);

//     useEffect(() => {
//         const initialisePage = async () => {
//             setIsInitialising(true);
//             setError(null);
//             try {
//                 const user = getLoggedInUser();
//                 if (!user || !user.id) throw new Error("User not authenticated.");

//                 const userRole = user.role?.name?.toUpperCase();
//                 setIsSuperAdmin(userRole === 'SUPER_ADMIN');
//                 setIsReportingManager(userRole === 'REPORTING MANAGER');

//                 const companyData = await getCompanyDetailsAPI();
//                 const currentCompanyKeyword = companyData?.message?.[0]?.companyKeyword || '';
//                 setCompanyKeyword(currentCompanyKeyword);

//                 const promises = [getUsers(), fetchHierarchyAPI(), getCustomersAPI(), getCommonMasterColumnAPI('vendor_type'), getTaggedTasksAPI()];
//                 if (currentCompanyKeyword === 'ZO') {
//                     const projectTemplatesPromise = getProjectTemplatesAPI().catch(err => {
//                         console.error("Non-critical error fetching project templates:", err.message);
//                         return [];
//                     });
//                     promises.push(projectTemplatesPromise);
//                 }
//                 const results = await Promise.all(promises);
//                 const [usersData, hierarchyData, customersData, vendorTypesData, taggedIds] = results;
//                 const templatesData = currentCompanyKeyword === 'ZO' ? results[5] : [];

//                 const activeUsers = usersData.filter(u => u.active === true);
//                 setAllUsers(activeUsers);
//                 const activeHierarchy = filterActiveHierarchy(hierarchyData);
//                 setFullHierarchy(activeHierarchy);
//                 setMasterVendorTypes(vendorTypesData);
//                 setProjectTemplates(templatesData);
//                 setTaggedTaskIds(new Set(taggedIds));

//                 if (userRole === 'REPORTING MANAGER' || userRole === 'SUPER_ADMIN') {
//                     const findUserNode = (nodes, userId) => {
//                         for (const node of nodes) {
//                             if (node.id === userId) return node;
//                             const found = findUserNode(node.children || [], userId);
//                             if (found) return found;
//                         }
//                         return null;
//                     };
//                     const userNode = findUserNode(activeHierarchy, user.id);
//                     const subordinateIds = userNode ? getSubordinateIds(userNode) : [user.id];
//                     const subordinateUsersList = activeUsers.filter(u => subordinateIds.includes(u.id));
//                     setSubordinateUsers(subordinateUsersList);
//                 }


//                 const customerTypeId = vendorTypesData.find(vt => vt.value?.toLowerCase() === 'customer')?.id;
//                 const supplierTypeId = vendorTypesData.find(vt => vt.value?.toLowerCase() === 'supplier')?.id;
//                 if (customersData.length > 0) {
//                     const activeCustomers = customersData.filter(c => c.active);
//                     setMasterCustomers(activeCustomers.filter(v => String(v.vendor_type) === String(customerTypeId)));
//                     setMasterSuppliers(activeCustomers.filter(v => String(v.vendor_type) === String(supplierTypeId)));
//                 }
//             } catch (err) {
//                 setError(err.message || 'Failed to load page metadata.');
//             } finally {
//                 setIsInitialising(false);
//             }
//         };
//         initialisePage();
//     }, []);

//     useEffect(() => {
//         if (isInitialising) return;
//         const fetchAndSetTasks = async () => {
//             setIsTasksLoading(true);
//             const user = getLoggedInUser();
//             let allowedUserIds = [];

//             if (isSuperAdmin) {
//                 allowedUserIds = allUsers.map(u => String(u.id));
//             } else if (user) {
//                 const findUserNode = (nodes, userId) => {
//                     for (const node of nodes) {
//                         if (node.id === userId) return node;
//                         const found = findUserNode(node.children || [], userId);
//                         if (found) return found;
//                     }
//                     return null;
//                 };
//                 const userNode = findUserNode(fullHierarchy, user.id);
//                 allowedUserIds = (userNode ? getSubordinateIds(userNode) : [user.id]).map(String);
//             }

//             let userIdsToFetch = [];
//             if (filterUserId && filterUserId.length > 0) {
//                 userIdsToFetch = allowedUserIds.filter(id => filterUserId.includes(id));
//             } else {
//                 userIdsToFetch = allowedUserIds;
//             }

//             try {
//                 const initialTasks = await fetchTasksByPage(1, userIdsToFetch);
//                 setAllScopedTasks(initialTasks);
//                 setCurrentPage(1);
//                 setHasMore(initialTasks.length > 0);
//             } catch (err) {
//                 setError(err.message);
//                 setAllScopedTasks([]);
//             } finally {
//                 setIsTasksLoading(false);
//             }
//         };
//         fetchAndSetTasks();
//     }, [isInitialising, isSuperAdmin, allUsers, fullHierarchy, fetchTasksByPage, filterUserId]);

//     const handleLoadMore = useCallback(async () => {
//         if (isLoadingMore || !hasMore) return;
//         setIsLoadingMore(true);
//         const nextPage = currentPage + 1;
//         const user = getLoggedInUser();

//         let allowedUserIds = [];
//         if (isSuperAdmin) {
//             allowedUserIds = allUsers.map(u => String(u.id));
//         } else if (user) {
//             const findUserNode = (nodes, userId) => {
//                 for (const node of nodes) {
//                     if (node.id === userId) return node;
//                     const found = findUserNode(node.children || [], userId);
//                     if (found) return found;
//                 }
//                 return null;
//             };
//             const userNode = findUserNode(fullHierarchy, user.id);
//             allowedUserIds = (userNode ? getSubordinateIds(userNode) : [user.id]).map(String);
//         }

//         let userIdsToFetch = [];
//         if (filterUserId && filterUserId.length > 0) {
//             userIdsToFetch = allowedUserIds.filter(id => filterUserId.includes(id));
//         } else {
//             userIdsToFetch = allowedUserIds;
//         }

//         try {
//             const newTasks = await fetchTasksByPage(nextPage, userIdsToFetch);
//             if (newTasks.length > 0) {
//                 setAllScopedTasks(prev => [...prev, ...newTasks]);
//                 setCurrentPage(nextPage);
//             } else {
//                 setHasMore(false);
//             }
//         } catch (err) {
//             setError('Failed to load more tasks.');
//         } finally {
//             setIsLoadingMore(false);
//         }
//     }, [currentPage, hasMore, isLoadingMore, fetchTasksByPage, isSuperAdmin, allUsers, fullHierarchy, filterUserId]);

//     const handleTaskDelete = async (taskId, parentId = null) => { const taskType = parentId ? 'subtask' : 'task'; if (!isSuperAdmin || !window.confirm(`Are you sure you want to delete this ${taskType}?`)) return; try { await deleteTaskApi(taskId); if (parentId) { setExpandedSubtasks(prev => { const parentSubtasks = prev[parentId] || { tasks: [] }; const updatedTasks = parentSubtasks.tasks.filter(st => st.taskId !== taskId); return { ...prev, [parentId]: { ...parentSubtasks, tasks: updatedTasks } }; }); setAllScopedTasks(prevTasks => prevTasks.map(pTask => pTask.taskId === parentId ? { ...pTask, no_of_sub_tasks: Math.max(0, (pTask.no_of_sub_tasks || 1) - 1) } : pTask)); } else { setAllScopedTasks(prevTasks => prevTasks.filter(t => t.taskId !== taskId)); } setInfoMessage(`${taskType.charAt(0).toUpperCase() + taskType.slice(1)} deleted successfully.`); setTimeout(() => setInfoMessage(null), 3000); } catch (err) { setError(err.response?.data?.message || `Failed to delete ${taskType}.`); } };
//     const handleCloneTask = (taskToClone) => { navigate('/tasks/create', { state: { taskToClone } }); };
//     const handleCreateSubtask = (parentTask) => { navigate('/tasks/create', { state: { parentTask, subtaskOnly: true } }); };
//     const handleToggleSubtasks = useCallback(async (taskId) => { const existing = expandedSubtasks[taskId]; if (existing?.isVisible) { setExpandedSubtasks(prev => ({ ...prev, [taskId]: { ...existing, isVisible: false } })); return; } if (existing && !existing.isVisible) { setExpandedSubtasks(prev => ({ ...prev, [taskId]: { ...existing, isVisible: true } })); return; } setExpandedSubtasks(prev => ({ ...prev, [taskId]: { isLoading: true, tasks: [], isVisible: true } })); try { const subtasks = await getSubTasksAPI(taskId); setExpandedSubtasks(prev => ({ ...prev, [taskId]: { isLoading: false, tasks: subtasks, isVisible: true } })); } catch (error) { console.error(`Failed to fetch subtasks for task ${taskId}:`, error); setExpandedSubtasks(prev => ({ ...prev, [taskId]: { isLoading: false, tasks: [], isVisible: true, error: error.message } })); } }, [expandedSubtasks]);

//     const handleTemplateSelect = (templateId) => {
//         setIsTemplateSelectionModalOpen(false);
//         navigate('/tasks/create-from-template', { state: { templateIdToLoad: templateId, isEditingDraft: false } });
//     };

//     const handleEditDraftSelect = (session) => {
//         setIsDraftSelectionModalOpen(false);
//         navigate('/tasks/create-from-template', {
//             state: {
//                 templateIdToLoad: session.template.projectTemplateId,
//                 isEditingDraft: true,
//                 draftTasksToLoad: session.tasks
//             }
//         });
//     };

//     const openDeleteDraftConfirm = (session) => {
//         setDraftToDelete(session);
//         setIsDraftDeleteConfirmOpen(true);
//     };

//     const confirmDeleteDraft = async () => {
//         if (!draftToDelete) return;
//         try {
//             const deletePromises = draftToDelete.tasks.map(task => deleteDraftTaskApi(task.draftTaskId));
//             await Promise.all(deletePromises);

//             setGroupedDrafts(prevGrouped => {
//                 return prevGrouped.map(group => {
//                     if (group.template.projectTemplateId === draftToDelete.template.projectTemplateId) {
//                         const updatedSessions = group.sessions.filter(session => session.savedAt !== draftToDelete.savedAt);
//                         return { ...group, sessions: updatedSessions };
//                     }
//                     return group;
//                 }).filter(group => group.sessions.length > 0);
//             });

//             setInfoMessage("Draft deleted successfully.");
//             setTimeout(() => setInfoMessage(null), 3000);
//         } catch (err) {
//             setTemplateError(err.message || "Failed to delete the draft.");
//         } finally {
//             setIsDraftDeleteConfirmOpen(false);
//             setDraftToDelete(null);
//         }
//     };

//     const openAssignDraftModal = (session) => {
//         setDraftToAssign(session);
//         setIsAssignDraftModalOpen(true);
//     };

//     const confirmAssignDraft = async (selectedUserId) => {
//         if (!draftToAssign || !selectedUserId) return;
//         try {
//             const assignPromises = draftToAssign.tasks.map(task => updateDraftAssigneeApi(task.draftTaskId, selectedUserId));
//             await Promise.all(assignPromises);

//             const newAssignee = allUsers.find(u => u.id === selectedUserId);

//             setGroupedDrafts(prevGrouped => {
//                 return prevGrouped.map(group => {
//                     if (group.template.projectTemplateId === draftToAssign.template.projectTemplateId) {
//                         const updatedSessions = group.sessions.map(session => {
//                             if (session.savedAt === draftToAssign.savedAt) {
//                                 return { ...session, assigneeName: newAssignee?.name || session.assigneeName };
//                             }
//                             return session;
//                         });
//                         return { ...group, sessions: updatedSessions };
//                     }
//                     return group;
//                 });
//             });

//             setInfoMessage(`Draft assigned to ${newAssignee?.name} successfully.`);
//             setTimeout(() => setInfoMessage(null), 3000);

//         } catch (err) {
//             setTemplateError(err.message || "Failed to assign the draft.");
//         } finally {
//             setIsAssignDraftModalOpen(false);
//             setDraftToAssign(null);
//         }
//     };


//     const handleOpenDraftsModal = async () => {
//         setModalSearchTerm('');
//         setIsDraftSelectionModalOpen(true);
//         setIsCheckingForDrafts(true);
//         setGroupedDrafts([]);
//         setExpandedTemplateId(null);
//         setTemplateError(null);
//         try {
//             const currentUser = getLoggedInUser();
//             if (!currentUser || !currentUser.id) {
//                 throw new Error("Could not identify the current user to filter drafts.");
//             }

//             const findUserNode = (nodes, userId) => {
//                 for (const node of nodes) {
//                     if (node.id === userId) return node;
//                     const found = findUserNode(node.children || [], userId);
//                     if (found) return found;
//                 }
//                 return null;
//             };

//             const userNode = findUserNode(fullHierarchy, currentUser.id);
//             const subordinateIds = userNode ? getSubordinateIds(userNode) : [currentUser.id];
//             const subordinateIdsSet = new Set(subordinateIds.map(id => String(id)));

//             const hierarchicalUsers = allUsers.filter(u => subordinateIdsSet.has(String(u.id)));
//             const hierarchicalUserNames = new Set(hierarchicalUsers.map(u => u.name));

//             const draftPromises = projectTemplates.map(async (template) => {
//                 const draftData = await getDraftsByTemplateId(template.projectTemplateId);
//                 return { template, draftTasks: draftData.draft_tasks || [] };
//             });

//             const results = await Promise.all(draftPromises);

//             const draftsByTemplate = [];
//             for (const result of results) {
//                 if (result.draftTasks.length > 0) {
//                     const sessions = groupDraftsIntoSessions(result.draftTasks, result.template);
//                     const userAndSubordinateSessions = sessions.filter(session => hierarchicalUserNames.has(session.createdBy));
//                     if (userAndSubordinateSessions.length > 0) {
//                         draftsByTemplate.push({
//                             template: result.template,
//                             sessions: userAndSubordinateSessions.sort((a, b) => new Date(b.savedAt) - new Date(a.savedAt))
//                         });
//                     }
//                 }
//             }

//             draftsByTemplate.sort((a, b) => a.template.projectTemplateName.localeCompare(b.template.projectTemplateName));
//             setGroupedDrafts(draftsByTemplate);

//         } catch (err) {
//             setTemplateError(err.message || "Could not check for drafts.");
//         } finally {
//             setIsCheckingForDrafts(false);
//         }
//     };

//     const handleToggleTemplateExpansion = (templateId) => {
//         setExpandedTemplateId(prevId => (prevId === templateId ? null : templateId));
//     };

//     const formatModalDate = (dateString) => {
//         if (!dateString) return 'N/A';
//         return new Date(dateString).toLocaleString('en-GB', {
//             day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit'
//         });
//     };

//     const filteredProjectTemplates = useMemo(() => {
//         if (!modalSearchTerm) return projectTemplates;
//         const searchTermLower = modalSearchTerm.toLowerCase();
//         return projectTemplates.filter(template =>
//             template.projectTemplateName.toLowerCase().includes(searchTermLower) ||
//             formatModalDate(template.createdAt).toLowerCase().includes(searchTermLower) ||
//             formatModalDate(template.updatedAt).toLowerCase().includes(searchTermLower)
//         );
//     }, [projectTemplates, modalSearchTerm]);

//     const filteredGroupedDrafts = useMemo(() => {
//         if (!modalSearchTerm) return groupedDrafts;
//         const searchTermLower = modalSearchTerm.toLowerCase();
//         return groupedDrafts.map(group => {
//             const matchingSessions = group.sessions.filter(session =>
//                 session.displayName.toLowerCase().includes(searchTermLower) ||
//                 (session.createdBy && session.createdBy.toLowerCase().includes(searchTermLower)) ||
//                 (session.assigneeName && session.assigneeName.toLowerCase().includes(searchTermLower)) ||
//                 formatModalDate(session.savedAt).toLowerCase().includes(searchTermLower)
//             );
//             const templateNameMatches = group.template.projectTemplateName.toLowerCase().includes(searchTermLower);
//             if (templateNameMatches) {
//                 return group;
//             } else if (matchingSessions.length > 0) {
//                 return { ...group, sessions: matchingSessions };
//             }
//             return null;
//         }).filter(Boolean);
//     }, [groupedDrafts, modalSearchTerm]);

//     const usersMap = useMemo(() => new Map(allUsers.map(u => [u.id, u])), [allUsers]);
//     const enrichedTasks = useMemo(() => { const customerMap = new Map([...masterCustomers, ...masterSuppliers].map(c => [c.id, c.name])); const tasksWithActiveAssignee = allScopedTasks.filter(task => usersMap.has(task.assigneeId)); return tasksWithActiveAssignee.map(task => { const user = usersMap.get(task.assigneeId); const vendor = [...masterCustomers, ...masterSuppliers].find(v => v.id === task.customerId); return { task: { ...task, customerName: task.customerId ? customerMap.get(task.customerId) : null, vendorTypeId: vendor ? vendor.vendor_type : null }, user: user }; }); }, [allScopedTasks, usersMap, masterCustomers, masterSuppliers]);
//     const enrichedAndFilteredTasks = useMemo(() => { return enrichedTasks.filter(item => taskMatchesFilters(item.task, item.user, filters)).sort((a, b) => new Date(b.task.createdAt) - new Date(a.task.createdAt)); }, [enrichedTasks, filters]);
//     const { statusOptions, priorityOptions, projectOptions, categoryOptions, departmentOptions, userOptions, defaultUserLabel, vendorTypeOptions, yearOptions, monthOptionsForFilter } = useMemo(() => {
//         const createDynamicOptions = (keyToExclude) => {
//             const tempFilters = { ...filters, [keyToExclude]: [] };
//             const availableTasks = enrichedTasks.filter(item => taskMatchesFilters(item.task, item.user, tempFilters));
//             let valueSet;
//             if (keyToExclude === 'department') {
//                 const departmentNames = availableTasks.map(item => item.user.department?.departmentName).filter(Boolean);
//                 valueSet = new Set(departmentNames);
//             } else {
//                 valueSet = new Set(availableTasks.map(item => item.task[keyToExclude]).filter(Boolean));
//             }
//             return Array.from(valueSet).map(value => ({ value: normalizeForComparison(value), label: String(value) })).sort((a, b) => (a.label || '').localeCompare(b.label || ''));
//         };

//         let staticUserOpts = [];
//         let userLabel = 'Select User';
//         const user = getLoggedInUser();
//         if (isSuperAdmin) {
//             staticUserOpts = allUsers.map(u => ({ value: String(u.id), label: u.name })).sort((a, b) => (a.label || '').localeCompare(b.label || ''));
//             userLabel = 'All Users';
//         } else if (user && fullHierarchy.length > 0) {
//             const findUserNode = (nodes, userId) => { for (const node of nodes) { if (node.id === userId) return node; const found = findUserNode(node.children || [], userId); if (found) return found; } return null; };
//             const userNode = findUserNode(fullHierarchy, user.id);
//             const subordinateIds = userNode ? getSubordinateIds(userNode) : [user.id];
//             const subordinateIdsSet = new Set(subordinateIds);
//             staticUserOpts = allUsers.filter(u => subordinateIdsSet.has(u.id)).map(u => ({ value: String(u.id), label: u.name })).sort((a, b) => (a.label || '').localeCompare(b.label || ''));
//             userLabel = userNode?.children?.length > 0 ? 'My Team' : 'My Tasks';
//         }
//         if (filterUserId.length === 1) {
//             userLabel = allUsers.find(u => String(u.id) === filterUserId[0])?.name || 'Selected User';
//         } else if (filterUserId.length > 1) {
//             userLabel = `${filterUserId.length} Users Selected`;
//         }

//         const dateSets = { years: new Set(), months: new Set() };
//         enrichedAndFilteredTasks.forEach(({ task }) => {
//             if (task.createdAt) {
//                 const financialYear = getFinancialYear(task.createdAt);
//                 if (financialYear) dateSets.years.add(financialYear);
//                 dateSets.months.add(new Date(task.createdAt).getMonth());
//             }
//         });

//         // UPDATED MONTH OPTIONS LOGIC: Show all months (1-12) with correct labels
//         const monthOpts = DATE_PICKER_MONTHS.map(m => ({ value: m.value, label: m.name }));

//         const yearOpts = Array.from(dateSets.years).sort((a, b) => (b || '').localeCompare(a || '')).map(y => ({ value: y, label: y }));
//         const vendOptions = masterVendorTypes.map(vt => ({ value: String(vt.id), label: vt.value })).sort((a, b) => (a.label || '').localeCompare(b.label || ''));

//         const baseStatusOptions = createDynamicOptions('status');
//         const hasUnderReview = baseStatusOptions.some(opt => opt.value === 'under_review');
//         const finalStatusOptions = hasUnderReview
//             ? baseStatusOptions
//             : [...baseStatusOptions, { value: 'under_review', label: 'Under Review' }].sort((a, b) => (a.label || '').localeCompare(b.label || ''));

//         return {
//             statusOptions: finalStatusOptions,
//             priorityOptions: createDynamicOptions('priority'),
//             projectOptions: createDynamicOptions('projectName'),
//             categoryOptions: createDynamicOptions('category'),
//             departmentOptions: createDynamicOptions('department'),
//             userOptions: staticUserOpts,
//             defaultUserLabel: userLabel,
//             vendorTypeOptions: vendOptions,
//             yearOptions: yearOpts,
//             monthOptionsForFilter: monthOpts,
//         };
//     }, [enrichedTasks, filters, allUsers, isSuperAdmin, fullHierarchy, masterVendorTypes, enrichedAndFilteredTasks]);

//     const customerVendorTypeId = useMemo(() => masterVendorTypes.find(vt => vt.value?.toLowerCase() === 'customer')?.id, [masterVendorTypes]);
//     const supplierVendorTypeId = useMemo(() => masterVendorTypes.find(vt => vt.value?.toLowerCase() === 'supplier')?.id, [masterVendorTypes]);
//     const displayedHierarchy = useMemo(() => { if (viewMode !== 'tree' || fullHierarchy.length === 0 || enrichedAndFilteredTasks.length === 0) return []; const hierarchyCopy = JSON.parse(JSON.stringify(fullHierarchy)); const nodeMap = new Map(); function traverseAndMap(nodes) { for (const node of nodes) { node.tasks = []; nodeMap.set(node.id, node); if (node.children) traverseAndMap(node.children); } } traverseAndMap(hierarchyCopy); enrichedAndFilteredTasks.forEach(item => { if (item.task.assigneeId && nodeMap.has(item.task.assigneeId)) { nodeMap.get(item.task.assigneeId).tasks.push(item.task); } }); return hierarchyCopy; }, [fullHierarchy, enrichedAndFilteredTasks, viewMode]);


//     if (isInitialising) {
//         return (<div className="tasks-list-page-loading"><div className="loader-spinner"></div><p>Loading application...</p></div>);
//     }

//     return (
//         <div className="tasks-list-page">
//             <TemplatePreviewModal
//                 isOpen={isPreviewModalOpen}
//                 onClose={handleClosePreviewModal}
//                 template={templateToPreview}
//             />
//             <Modal
//                 isOpen={isTemplateSelectionModalOpen}
//                 onClose={() => setIsTemplateSelectionModalOpen(false)}
//                 title="Select a Project Template"
//             >
//                 <div className="template-modal-search">
//                     <IoSearchOutline />
//                     <input
//                         type="text"
//                         placeholder="Search templates by name or date..."
//                         value={modalSearchTerm}
//                         onChange={(e) => setModalSearchTerm(e.target.value)}
//                         autoFocus
//                     />
//                 </div>
//                 <div className="template-options-list">
//                     {filteredProjectTemplates.length > 0 ? (
//                         filteredProjectTemplates.map(template => (
//                             <div key={template.projectTemplateId} className="template-list-item">
//                                 <div className="template-item-clickable-area" onClick={() => handleTemplateSelect(template.projectTemplateId)}>
//                                     <div className="template-item-icon"><IoDocumentsOutline /></div>
//                                     <div className="template-item-details">
//                                         <div className="template-item-name">{template.projectTemplateName}</div>
//                                         <div className="template-item-meta">
//                                             <span>Created: {formatModalDate(template.createdAt)}</span>
//                                             <span>Updated: {formatModalDate(template.updatedAt)}</span>
//                                         </div>
//                                     </div>
//                                 </div>
//                                 <div className="template-item-action-wrapper">
//                                     <button
//                                         onClick={(e) => {
//                                             e.stopPropagation();
//                                             handleOpenPreviewModal(template);
//                                         }}
//                                         className="action-btn preview-btn"
//                                         title="Preview Template"
//                                     >
//                                         <IoEyeOutline size={18} />
//                                     </button>
//                                     <IoChevronForwardOutline className="forward-icon" onClick={() => handleTemplateSelect(template.projectTemplateId)} />
//                                 </div>
//                             </div>
//                         ))
//                     ) : (
//                         <div className="template-option-message empty">
//                             <IoDocumentsOutline />
//                             <span>{modalSearchTerm ? 'No templates found matching your search.' : 'No templates found.'}</span>
//                         </div>
//                     )}
//                 </div>
//             </Modal>

//             <Modal
//                 isOpen={isDraftSelectionModalOpen}
//                 onClose={() => setIsDraftSelectionModalOpen(false)}
//                 title="Select a Draft to Edit"
//             >
//                 <div className="template-modal-search">
//                     <IoSearchOutline />
//                     <input
//                         type="text"
//                         placeholder="Search by template, draft title, creator, or assignee..."
//                         value={modalSearchTerm}
//                         onChange={(e) => setModalSearchTerm(e.target.value)}
//                         autoFocus
//                     />
//                 </div>
//                 <div className="template-options-list">
//                     {isCheckingForDrafts ? (
//                         <div className="template-option-message">
//                             <div className="loader-spinner small"></div>
//                             <span>Checking for your team's drafts...</span>
//                         </div>
//                     ) : filteredGroupedDrafts.length > 0 ? (
//                         filteredGroupedDrafts.map(group => (
//                             <div key={group.template.projectTemplateId} className="template-group-container">
//                                 <div
//                                     className="template-list-item is-expandable"
//                                     onClick={() => handleToggleTemplateExpansion(group.template.projectTemplateId)}
//                                 >
//                                     <div className="template-item-icon"><IoDocumentsOutline /></div>
//                                     <div className="template-item-details">
//                                         <div className="template-item-name">{group.template.projectTemplateName}</div>
//                                         <div className="template-item-meta">
//                                             <span>{group.sessions.length} draft(s) saved</span>
//                                         </div>
//                                     </div>
//                                     <div className="template-item-action">
//                                         <IoChevronDown className={`expansion-arrow ${expandedTemplateId === group.template.projectTemplateId ? 'expanded' : ''}`} />
//                                     </div>
//                                 </div>

//                                 {expandedTemplateId === group.template.projectTemplateId && (
//                                     <div className="draft-sessions-list">
//                                         {group.sessions.map(session => (
//                                             <div key={session.savedAt} className="template-list-item-draft">
//                                                 <div className="template-item-clickable-area" onClick={() => handleEditDraftSelect(session)}>
//                                                     <div className="template-item-icon draft"><IoCreateOutline /></div>
//                                                     <div className="template-item-details">
//                                                         <div className="template-item-name">
//                                                             <span className="draft-title">{session.displayName}</span>
//                                                         </div>
//                                                         <div className="template-item-meta">
//                                                             <span>Saved: {formatModalDate(session.savedAt)}</span>
//                                                             {session.createdBy && <span>By: {session.createdBy}</span>}
//                                                             {session.assigneeName && <span>Assigned to: {session.assigneeName}</span>}
//                                                         </div>
//                                                     </div>
//                                                 </div>
//                                                 <div className="template-item-action-wrapper">
//                                                     {(isSuperAdmin || isReportingManager) && (
//                                                         <button
//                                                             onClick={(e) => {
//                                                                 e.stopPropagation();
//                                                                 openAssignDraftModal(session);
//                                                             }}
//                                                             className="action-btn assign-btn"
//                                                             title="Assign Draft"
//                                                         >
//                                                             <IoPersonAddOutline size={16} />
//                                                         </button>
//                                                     )}
//                                                     <button
//                                                         onClick={(e) => {
//                                                             e.stopPropagation();
//                                                             openDeleteDraftConfirm(session);
//                                                         }}
//                                                         className="action-btn delete-btn"
//                                                         title="Delete Draft"
//                                                     >
//                                                         <IoTrashOutline size={16} />
//                                                     </button>
//                                                     <IoChevronForwardOutline className="forward-icon" onClick={() => handleEditDraftSelect(session)} />
//                                                 </div>
//                                             </div>
//                                         ))}
//                                     </div>
//                                 )}
//                             </div>
//                         ))
//                     ) : (
//                         <div className="template-option-message empty">
//                             <IoCreateOutline />
//                             <span>{groupedDrafts.length > 0 ? 'No drafts found matching your search.' : 'No saved drafts found for you or your team.'}</span>
//                         </div>
//                     )}
//                 </div>
//             </Modal>

//             <ConfirmationModal
//                 isOpen={isDraftDeleteConfirmOpen}
//                 onClose={() => setIsDraftDeleteConfirmOpen(false)}
//                 onConfirm={confirmDeleteDraft}
//                 title="Confirm Deletion"
//             >
//                 <p>Are you sure you want to delete this draft session?</p>
//                 {draftToDelete && (
//                     <div className="draft-delete-details">
//                         <strong>{draftToDelete.displayName}</strong>
//                         <span>(Template: {draftToDelete.template.projectTemplateName})</span>
//                         <span>Saved: {formatModalDate(draftToDelete.savedAt)}</span>
//                     </div>
//                 )}
//                 <p className="warning-text">This will delete all tasks in this draft. This action cannot be undone.</p>
//             </ConfirmationModal>

//             <AssignDraftModal
//                 isOpen={isAssignDraftModalOpen}
//                 onClose={() => setIsAssignDraftModalOpen(false)}
//                 onConfirm={confirmAssignDraft}
//                 users={subordinateUsers}
//                 title="Assign Draft To"
//             />


//             <div className="tasks-list-header-static">
//                 <div className="page-header-tasks">
//                     <div className="header-content">
//                         <h1>Team Tasks</h1>
//                         <div className="view-toggle">
//                             <button className={`view-btn ${viewMode === 'tree' ? 'active' : ''}`} onClick={() => setViewMode('tree')} title="Tree View"><IoGitNetworkOutline /></button>
//                             <button className={`view-btn ${viewMode === 'compact-list' ? 'active' : ''}`} onClick={() => setViewMode('compact-list')} title="Compact List View"><IoReorderFourOutline /></button>
//                             <button className={`view-btn ${viewMode === 'list' ? 'active' : ''}`} onClick={() => setViewMode('list')} title="List View"><IoListOutline /></button>
//                             <button className={`view-btn ${viewMode === 'grid' ? 'active' : ''}`} onClick={() => setViewMode('grid')} title="Grid View"><IoGridOutline /></button>
//                         </div>
//                     </div>
//                     <div className="header-actions">
//                         {companyKeyword === 'ZO' && (
//                             <>
//                                 <button onClick={handleOpenDraftsModal} className="create-task-button-header secondary-btn">
//                                     <IoCreateOutline /> My Drafts
//                                 </button>
//                                 <button onClick={() => { setIsTemplateSelectionModalOpen(true); setModalSearchTerm(''); }} className="create-task-button-header template-btn">
//                                     <IoDocumentsOutline /> Use Template
//                                 </button>
//                             </>
//                         )}
//                         <Link to="/tasks/create" className="create-task-button-header">
//                             <IoAdd /> Create Task
//                         </Link>
//                     </div>
//                 </div>

//                 <div className="page-filters-container">
//                     <div className="search-row"><IoSearchOutline className="filter-icon" /><input type="text" placeholder="Search tasks, users, projects, customers..." value={searchTerm} onChange={handleSearchChange} /></div>
//                     <div className="dropdown-filters-row">
//                         <MultiSelectDropdown icon={<IoPeopleOutline className="filter-icon" />} options={userOptions} value={filterUserId} onChange={handleUserChange} defaultLabel={defaultUserLabel} />
//                         <MultiSelectDropdown icon={<IoPricetagOutline className="filter-icon" />} options={vendorTypeOptions} value={filterVendorTypes} onChange={handleVendorTypesChange} defaultLabel="All Vendor Types" />
//                         {customerVendorTypeId && filterVendorTypes.includes(String(customerVendorTypeId)) && (<MultiSelectDropdown icon={<IoBusinessOutline className="filter-icon" />} options={masterCustomers.map(c => ({ value: String(c.id), label: c.name }))} value={filterCustomers} onChange={handleCustomersChange} defaultLabel="All Customers" />)}
//                         {supplierVendorTypeId && filterVendorTypes.includes(String(supplierVendorTypeId)) && (<MultiSelectDropdown icon={<IoPeopleOutline className="filter-icon" />} options={masterSuppliers.map(s => ({ value: String(s.id), label: s.name }))} value={filterSuppliers} onChange={handleSuppliersChange} defaultLabel="All Suppliers" />)}
//                         <MultiSelectDropdown icon={<IoCheckmarkCircleOutline className="filter-icon" />} options={statusOptions} value={filterStatus} onChange={handleStatusChange} defaultLabel="All Statuses" />
//                         <MultiSelectDropdown icon={<IoFlagOutline className="filter-icon" />} options={priorityOptions} value={filterPriority} onChange={handlePriorityChange} defaultLabel="All Priorities" />
//                         <MultiSelectDropdown icon={<IoBriefcaseOutline className="filter-icon" />} options={projectOptions} value={filterProjectName} onChange={handleProjectChange} defaultLabel="All Projects" />
//                         <MultiSelectDropdown icon={<IoBusinessOutline className="filter-icon" />} options={departmentOptions} value={filterDepartment} onChange={handleDepartmentChange} defaultLabel="All Departments" />
//                         <MultiSelectDropdown icon={<IoPricetagOutline className="filter-icon" />} options={categoryOptions} value={filterCategory} onChange={handleCategoryChange} defaultLabel="All Categories" />
//                     </div>
//                     <div className="actions-row">
//                         <span className="date-filter-label">Filter by Date</span>
//                         <MultiSelectDropdown icon={<IoCalendarOutline className="filter-icon" />} options={yearOptions} value={filterYear} onChange={handleYearChange} defaultLabel="All Years" />
//                         <MultiSelectDropdown icon={<IoCalendarOutline className="filter-icon" />} options={monthOptionsForFilter} value={filterMonth} onChange={handleMonthChange} defaultLabel="All Months" />
//                         <div className="date-filter-group"><select value={dateFilterType} onChange={handleDateTypeChange}><option value="none">-- Date Type --</option><option value="created">Created</option><option value="completed">Completed</option><option value="due">Due</option></select></div>
//                         <div className="date-filter-group"><label>From</label>{dateFilterType === 'none' ? (<div className="date-placeholder">dd/mm/yyyy</div>) : (<div className="custom-date-inputs"><select value={fromDay} onChange={(e) => setFromDay(e.target.value)}>{daysInFromMonth.map(day => <option key={day} value={day}>{day}</option>)}</select><select value={fromMonth} onChange={(e) => setFromMonth(e.target.value)}>{DATE_PICKER_MONTHS.map(month => <option key={month.value} value={month.value}>{month.name}</option>)}</select><select value={fromYear} onChange={(e) => setFromYear(e.target.value)}>{years.map(year => <option key={year} value={year}>{year}</option>)}</select></div>)}</div>
//                         <div className="date-filter-group"><label>To</label>{dateFilterType === 'none' ? (<div className="date-placeholder">dd/mm/yyyy</div>) : (<div className="custom-date-inputs"><select value={toDay} onChange={(e) => setToDay(e.target.value)}>{daysInToMonth.map(day => <option key={day} value={day}>{day}</option>)}</select><select value={toMonth} onChange={(e) => setToMonth(e.target.value)}>{DATE_PICKER_MONTHS.map(month => <option key={month.value} value={month.value}>{month.name}</option>)}</select><select value={toYear} onChange={(e) => setToYear(e.target.value)}>{years.map(year => <option key={year} value={year}>{year}</option>)}</select></div>)}</div>
//                         <div className="view-and-reset-actions"><button className="reset-filters-btn" onClick={handleResetFilters} title="Reset all filters to default"><IoRefresh />Reset</button></div>
//                     </div>
//                 </div>
//             </div>

//             <div className="notification-area">
//                 {infoMessage && <div className="info-message">{infoMessage}</div>}
//                 {error && <div className="error-message">{error}</div>}
//                 {companyKeyword === 'ZO' && templateError && <div className="error-message">{templateError}</div>}
//             </div>

//             <div className={`content-container ${viewMode === 'compact-list' ? 'is-compact-view' : ''}`}>{isTasksLoading && allScopedTasks.length === 0 ? (<div className="tasks-grid-view-container">{Array.from({ length: 12 }).map((_, i) => <TaskCardSkeleton key={i} />)}</div>) : (<> {(enrichedAndFilteredTasks.length > 0 || Object.values(filters).some(val => Array.isArray(val) ? val.length > 0 : !!val)) && (<>{viewMode === 'tree' && (<> <div className="hierarchy-container">{displayedHierarchy.map((node) => (<UserNode key={node.id} node={node} isSuperAdmin={isSuperAdmin} onTaskDelete={handleTaskDelete} onCloneTask={handleCloneTask} onTaskSubtask={handleCreateSubtask} companyKeyword={companyKeyword} onToggleSubtasks={handleToggleSubtasks} expandedSubtasks={expandedSubtasks} targetTaskId={targetTaskId} filters={filters} taggedTaskIds={taggedTaskIds} />))}</div> <div className="load-more-container"><button onClick={handleLoadMore} className="load-more-btn" disabled={isLoadingMore || !hasMore}>{isLoadingMore ? 'Loading...' : (hasMore ? 'Load More' : 'No more tasks')}</button></div></>)}{viewMode === 'compact-list' && (<div className="tasks-compact-list-scroll-wrapper"><div className="tasks-compact-list-header"><div className="task-compact-list-id-section">ID</div><div className="task-compact-list-title-section">Title</div><div className="task-compact-list-project-section">Project</div><div className="task-compact-list-customer-section">Customer</div>{companyKeyword !== 'PL' && <div className="task-compact-list-subtask-section">Subtasks</div>}<div className="task-compact-list-category-section">Category</div><div className="task-compact-list-priority-section">Priority</div><div className="task-compact-list-status-section">Status</div><div className="task-compact-list-date-section">Due Date</div><div className="task-compact-list-user-section">Assignee</div><div className="task-compact-list-actions">Actions</div></div><div className="tasks-compact-list-container">{enrichedAndFilteredTasks.map((item, index) => (<div key={item.task.taskId} className="compact-list-item-wrapper"><TaskCompactListItem item={item} isSuperAdmin={isSuperAdmin} onTaskDelete={handleTaskDelete} onCloneTask={handleCloneTask} onTaskSubtask={handleCreateSubtask} companyKeyword={companyKeyword} index={index} isTargetTask={targetTaskId && String(item.task.taskId) === String(targetTaskId)} onToggleSubtasks={handleToggleSubtasks} subtaskData={expandedSubtasks[item.task.taskId]} navigate={navigate} isTagged={taggedTaskIds.has(item.task.taskId)} />{companyKeyword !== 'PL' && <SubtaskList parentTaskId={item.task.taskId} subtaskData={expandedSubtasks[item.task.taskId]} navigate={navigate} isSuperAdmin={isSuperAdmin} onTaskDelete={handleTaskDelete} />}</div>))}</div><div className="load-more-container"><button onClick={handleLoadMore} className="load-more-btn" disabled={isLoadingMore || !hasMore}>{isLoadingMore ? 'Loading...' : (hasMore ? 'Load More' : 'No more tasks')}</button></div></div>)}{(viewMode === 'list' || viewMode === 'grid') && (<> <div className={viewMode === 'list' ? "tasks-list-view-container" : "tasks-grid-view-container"}>{enrichedAndFilteredTasks.map((item, index) => (<TaskCard key={item.task.taskId} item={item} isSuperAdmin={isSuperAdmin} onTaskDelete={handleTaskDelete} onCloneTask={handleCloneTask} onTaskSubtask={handleCreateSubtask} companyKeyword={companyKeyword} onToggleSubtasks={handleToggleSubtasks} subtaskData={expandedSubtasks[item.task.taskId]} index={index} viewMode={viewMode} isTargetTask={targetTaskId && String(item.task.taskId) === String(targetTaskId)} isTagged={taggedTaskIds.has(item.task.taskId)} />))}</div> <div className="load-more-container"><button onClick={handleLoadMore} className="load-more-btn" disabled={isLoadingMore || !hasMore}>{isLoadingMore ? 'Loading...' : (hasMore ? 'Load More' : 'No more tasks')}</button></div></>)}</>)}{enrichedAndFilteredTasks.length === 0 && !isTasksLoading && (<div className="no-tasks-found-container">{filterTaskId ? (<h3>Task not found. It may be on a subsequent page or not within your current scope.</h3>) : (<h3>No tasks match the current filters.</h3>)}<p>Try adjusting your search or filter criteria.</p><button onClick={handleResetFilters} className="reset-filters-btn-empty"><IoRefresh /> Reset Filters</button></div>)}</>)}</div>
//         </div>
//     );
// };
// export default TasksListPage;







import React, { useState, useEffect, useCallback, useMemo, useRef } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { getLoggedInUser } from '../../utils/authHelper';
import {
    IoAdd,
    IoTrashOutline,
    IoSearchOutline,
    IoChevronDown,
    IoFlagOutline,
    IoGridOutline,
    IoListOutline,
    IoBriefcaseOutline,
    IoPeopleOutline,
    IoCheckmarkCircleOutline,
    IoPricetagOutline,
    IoCalendarOutline,
    IoChatbubbleEllipsesOutline,
    IoCheckmarkDoneCircleOutline,
    IoRefresh,
    IoGitNetworkOutline,
    IoWarningOutline,
    IoCopyOutline,
    IoReorderFourOutline,
    IoBusinessOutline,
    IoDocumentsOutline,
    IoClose,
    IoChevronForwardOutline,
    IoCreateOutline,
    IoPersonAddOutline,
    IoEyeOutline,
    IoReturnDownForwardOutline,
} from 'react-icons/io5';
import './TasksListPagestyle.css';

// --- Custom hook for debouncing input ---
const useDebounce = (value, delay) => {
    const [debouncedValue, setDebouncedValue] = useState(value);
    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedValue(value);
        }, delay);
        return () => {
            clearTimeout(handler);
        };
    }, [value, delay]);
    return debouncedValue;
};


// --- Configuration & API ---
const SWAGGER_BASE_URL = process.env.REACT_APP_SWAGGER_SERVICE_BASE_URL;
const NODE_BASE_URL = process.env.REACT_APP_NODE_SERVICE_BASE_URL;
const AUTH_TOKEN_KEY = 'zTaskAuthToken';
const TASKS_PER_PAGE = 20;
const SESSION_STORAGE_KEY = 'taskListPageState';

const getAuthToken = () => localStorage.getItem(AUTH_TOKEN_KEY);
const getApiHeaders = () => ({ 'Authorization': `Bearer ${getAuthToken()}`, 'accept': 'application/json' });

const getDraftsByTemplateId = async (templateId) => {
    const response = await fetch(`${SWAGGER_BASE_URL}/api/get-all-draft-task-by-template-id?templateId=${templateId}`, { headers: getApiHeaders() });
    if (!response.ok) {
        if (response.status === 404 || response.status === 400) {
            return { draft_tasks: [] };
        }
        throw new Error(`Failed to fetch drafts for template ${templateId}`);
    }
    return response.json();
};

const deleteDraftTaskApi = async (draftTaskId) => {
    const response = await fetch(`${SWAGGER_BASE_URL}/api/delete-draft-task?draftTaskId=${draftTaskId}`, {
        method: 'DELETE',
        headers: getApiHeaders(),
    });
    if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.message || 'Could not delete draft task');
    }
    return response.json();
};

const updateDraftAssigneeApi = async (draftTaskId, userId) => {
    const response = await fetch(`${SWAGGER_BASE_URL}/api/update-assignee-in-draft-task?draftTaskId=${draftTaskId}&userId=${userId}`, {
        method: 'PUT',
        headers: getApiHeaders(),
    });
    if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.message || 'Could not update draft task assignee');
    }
    return response.json();
};


// --- Date Helpers ---
const pad = (num) => num.toString().padStart(2, '0');
const today = new Date();
const currentYear = today.getFullYear();
const currentMonth = today.getMonth() + 1;
const currentDay = today.getDate();

const years = Array.from({ length: 101 }, (_, i) => currentYear - 50 + i);
const DATE_PICKER_MONTHS = [
    { value: '1', name: 'Jan' }, { value: '2', name: 'Feb' }, { value: '3', name: 'Mar' },
    { value: '4', name: 'Apr' }, { value: '5', name: 'May' }, { value: '6', name: 'Jun' },
    { value: '7', name: 'Jul' }, { value: '8', name: 'Aug' }, { value: '9', name: 'Sep' },
    { value: '10', name: 'Oct' }, { value: '11', name: 'Nov' }, { value: '12', name: 'Dec' }
];
const getDaysInMonth = (year, month) => new Date(parseInt(year, 10), parseInt(month, 10), 0).getDate();

// Unified Normalization Helper
const normalizeForComparison = (str) => String(str || '').toLowerCase().trim().replace(/[\s-]/g, '_');

const getStatusClass = (status) => status ? normalizeForComparison(status).replace(/_/g, '-') : 'default';

// --- API & Utility Functions ---
const getCompanyDetailsAPI = async () => {
    const response = await fetch(`${SWAGGER_BASE_URL}/api/get-company`, { headers: getApiHeaders() });
    if (!response.ok) throw new Error('Failed to fetch company details');
    return response.json();
};

const getSubTasksAPI = async (parentTaskId) => {
    const response = await fetch(`${SWAGGER_BASE_URL}/api/get-sub-tasks?parentTaskId=${parentTaskId}`, { headers: getApiHeaders() });
    if (response.status === 400) {
        const errorData = await response.json().catch(() => ({}));
        if (errorData.message === "sub task list is empty") { return []; }
    }
    if (!response.ok) throw new Error(`Failed to fetch subtasks for task ${parentTaskId}: ${response.status}`);
    const data = await response.json();
    return data.data || [];
};

const getCustomersAPI = async () => {
    const response = await fetch(`${NODE_BASE_URL}/customer/api/customers/`, { headers: getApiHeaders() });
    if (!response.ok) throw new Error(`Failed to fetch customers: ${response.status}`);
    return response.json();
};

const fetchHierarchyAPI = async () => {
    const response = await fetch(`${SWAGGER_BASE_URL}/api-get-full-hierarchy-tree`, { headers: getApiHeaders() });
    if (!response.ok) throw new Error(`Failed to fetch hierarchy: ${response.status}`);
    return (await response.json()).tree || [];
};

const getCommonMasterColumnAPI = async (columnName) => {
    const response = await fetch(`${NODE_BASE_URL}/api/get-column/common_master/${columnName}`, { headers: getApiHeaders() });
    if (!response.ok) throw new Error(`Failed to fetch ${columnName}: ${response.status}`);
    return response.json();
};

const getProjectTemplatesAPI = async () => {
    const response = await fetch(`${SWAGGER_BASE_URL}/api/get-Project Template`, { headers: getApiHeaders() });
    if (!response.ok) throw new Error('Failed to fetch project templates');
    const data = await response.json();
    return data.project_template || [];
};

const getTasksByUserIdAPI = async (userId, page = 1, size = TASKS_PER_PAGE) => {
    if (!userId) {
        console.warn('getTasksByUserIdAPI was called with an invalid userId:', userId);
        return [];
    }
    const response = await fetch(`${SWAGGER_BASE_URL}/api/get-task-by-userId?userId=${userId}&page=${page}&size=${size}`, { headers: getApiHeaders() });
    if (response.status === 404) return [];
    if (!response.ok) throw new Error(`Failed to fetch tasks for user ${userId}: ${response.status}`);
    const data = await response.json();
    return (data.data || []).map(task => ({
        taskId: task.task_id,
        parentTaskId: task.parent_task_id,
        title: task.title,
        description: task.description,
        status: task.status,
        priority: task.priority,
        assigneeName: task.assignee_name,
        category: task.category,
        createdBy: task.created_by,
        completedAt: task.completed_at,
        remainingTime: task.remaining_time,
        no_of_sub_tasks: task.no_of_sub_tasks,
        projectName: task.project_name,
        remarks: task.remarks,
        comments: task.comments,
        createdAt: task.created_at,
        updatedAt: task.updated_at,
        dueDate: task.due_date,
        customerId: task.customer_id,
        projectId: task.project_id,
        assigneeId: task.assignee_id
    }));
};

const getUsers = async () => {
    const response = await fetch(`${SWAGGER_BASE_URL}/api/get-users`, { headers: getApiHeaders() });
    if (!response.ok) throw new Error('Failed to fetch users');
    return (await response.json()).userData || [];
};

const deleteTaskApi = async (taskId) => {
    const response = await fetch(`${SWAGGER_BASE_URL}/api/delete-task?taskId=${taskId}`, { method: 'DELETE', headers: getApiHeaders() });
    if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.message || 'Failed to delete task');
    }
    return response.json();
};

const getTaggedTasksAPI = async () => {
    const response = await fetch(`${SWAGGER_BASE_URL}/api/get-tagged-tasks-id`, { headers: getApiHeaders() });
    if (!response.ok) {
        console.error('Failed to fetch tagged task IDs, color-coding will be disabled.');
        return [];
    }
    const data = await response.json();
    return (data.tagged_task_ids || []).map(item => item.task_id);
};

const groupDraftsIntoSessions = (flatDraftTasks, template) => {
    if (!flatDraftTasks || flatDraftTasks.length === 0) {
        return [];
    }
    const sessionsMap = new Map();
    flatDraftTasks.forEach(task => {
        const groupKey = task.createdAt ? new Date(task.createdAt).setMilliseconds(0).toString() : 'no-timestamp';
        if (!sessionsMap.has(groupKey)) {
            sessionsMap.set(groupKey, []);
        }
        sessionsMap.get(groupKey).push(task);
    });
    const sessions = [];
    for (const [timestampKey, tasksInSession] of sessionsMap.entries()) {
        if (tasksInSession.length > 0) {
            const representativeTask = tasksInSession.find(t => t.parentTaskId === 0) || tasksInSession[0];
            sessions.push({
                sessionId: representativeTask.draftTaskId,
                savedAt: representativeTask.createdAt,
                createdBy: representativeTask.createdBy,
                assigneeName: representativeTask.assigneeName,
                displayName: `Draft: "${representativeTask.title}"`,
                template: template,
                tasks: tasksInSession,
            });
        }
    }
    return sessions;
};

const getSubordinateIds = (node) => {
    if (!node) return [];
    let ids = [node.id];
    (node.children || []).forEach(child => { ids = ids.concat(getSubordinateIds(child)); });
    return ids;
};

const getFinancialYear = (date) => {
    if (!date || isNaN(new Date(date))) return null;
    const d = new Date(date);
    const year = d.getFullYear();
    const month = d.getMonth();
    return month >= 3 ? `${year}-${year + 1}` : `${year - 1}-${year}`;
};

const filterActiveHierarchy = (nodes) => {
    if (!Array.isArray(nodes)) return [];
    return nodes
        .filter(node => node.active === true)
        .map(node => ({ ...node, children: filterActiveHierarchy(node.children), }));
};

const taskMatchesFilters = (task, userNode, filters) => {
    if (!task || !userNode || !filters) return false;

    if (filters.taskId) {
        return String(task.taskId) === filters.taskId;
    }

    if (task.parentTaskId) return false;
    const { searchTerm, status, priority, projectName, userId, category, year, month, dateFilterType, dateFrom, dateTo, department, vendorTypes, customers, suppliers } = filters;
    if (userId.length > 0 && !userId.includes(String(task.assigneeId))) return false;
    if (vendorTypes.length > 0 && (task.vendorTypeId == null || !vendorTypes.includes(String(task.vendorTypeId)))) return false;
    const selectedVendors = [...customers, ...suppliers];
    if (selectedVendors.length > 0 && (task.customerId == null || !selectedVendors.includes(String(task.customerId)))) return false;
    if (department.length > 0) {
        const userDepartmentName = userNode.department?.departmentName?.replace(/ /g, '_');
        if (!userDepartmentName || !department.includes(userDepartmentName)) return false;
    }

    if (status.length > 0) {
        const taskStatusKey = normalizeForComparison(task.status);
        const filterStatusKeys = status.map(normalizeForComparison);
        if (!filterStatusKeys.includes(taskStatusKey)) return false;
    }
    if (priority.length > 0) {
        const taskPriorityKey = normalizeForComparison(task.priority);
        const filterPriorityKeys = priority.map(normalizeForComparison);
        if (!filterPriorityKeys.includes(taskPriorityKey)) return false;
    }
    if (projectName.length > 0) {
        const normalizedTaskProjectName = normalizeForComparison(task.projectName);
        const normalizedFilterProjects = projectName.map(normalizeForComparison);
        if (!normalizedFilterProjects.includes(normalizedTaskProjectName)) return false;
    }
    if (category.length > 0) {
        const normalizedTaskCategory = normalizeForComparison(task.category);
        const normalizedFilterCategories = category.map(normalizeForComparison);
        if (!normalizedFilterCategories.includes(normalizedTaskCategory)) return false;
    }

    if (year.length > 0 || month.length > 0) {
        if (!task.createdAt) return false;
        const taskDate = new Date(task.createdAt);
        if (isNaN(taskDate.getTime())) return false;
        if (year.length > 0) {
            const financialYear = getFinancialYear(task.createdAt);
            if (!financialYear || !year.includes(financialYear)) {
                return false;
            }
        }
        if (month.length > 0 && !month.map(Number).includes(taskDate.getMonth() + 1)) {
            return false;
        }
    }
    if (dateFilterType !== 'none' && dateFrom && dateTo) {
        let taskDateString;
        if (dateFilterType === 'created') taskDateString = task.createdAt;
        else if (dateFilterType === 'completed') taskDateString = task.completedAt;
        else if (dateFilterType === 'due') taskDateString = task.dueDate;
        if (!taskDateString) return false;
        try {
            const taskDate = new Date(taskDateString); taskDate.setHours(0, 0, 0, 0);
            const fromDate = new Date(dateFrom); fromDate.setHours(0, 0, 0, 0);
            const toDate = new Date(dateTo); toDate.setHours(23, 59, 59, 999);
            if (taskDate < fromDate || taskDate > toDate) return false;
        } catch (e) { return false; }
    }
    const lowerSearchTerm = searchTerm.toLowerCase().trim();
    if (!lowerSearchTerm) return true;
    const commentsMatch = task.comments?.some(comment => comment && comment.toLowerCase().includes(lowerSearchTerm));
    return (
        task.title?.toLowerCase().includes(lowerSearchTerm) ||
        task.description?.toLowerCase().includes(lowerSearchTerm) ||
        task.taskId?.toString().includes(lowerSearchTerm) ||
        userNode.name?.toLowerCase().includes(lowerSearchTerm) ||
        task.projectName?.toLowerCase().replace(/_/g, ' ').includes(lowerSearchTerm) ||
        task.customerName?.toLowerCase().includes(lowerSearchTerm) ||
        task.status?.toLowerCase().replace(/[\s_-]/g, ' ').includes(lowerSearchTerm) ||
        task.priority?.toLowerCase().includes(lowerSearchTerm) ||
        task.category?.toLowerCase().replace(/_/g, ' ').includes(lowerSearchTerm) ||
        task.createdBy?.toLowerCase().includes(lowerSearchTerm) ||
        commentsMatch
    );
};
const nodeHasVisibleContent = (node, filters) => {
    if (!node) return false;
    if ((node.tasks || []).some(task => taskMatchesFilters(task, node, filters))) return true;
    return (node.children || []).some(child => nodeHasVisibleContent(child, filters));
};

const useOutsideAlerter = (ref, callback) => { useEffect(() => { const handleClickOutside = (event) => { if (ref.current && !ref.current.contains(event.target)) { callback(); } }; document.addEventListener('mousedown', handleClickOutside); return () => document.removeEventListener('mousedown', handleClickOutside); }, [ref, callback]); };

const UserProfileImage = ({ userName, className }) => (<div className={className}>{userName ? userName.charAt(0).toUpperCase() : ''}</div>);
const TaskCardSkeleton = () => (<div className="task-card task-card-skeleton"><div className="task-content-area"><div className="task-card-header"><div className="shimmer-line shimmer-title"></div><div className="shimmer-block shimmer-badge"></div></div><div className="shimmer-line shimmer-desc"></div><div className="shimmer-line shimmer-desc-short"></div><div className="task-meta"><div className="shimmer-block shimmer-meta"></div><div className="shimmer-block shimmer-meta"></div></div></div></div>);

const MultiSelectDropdown = ({ options, value, onChange, icon, defaultLabel }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const wrapperRef = useRef(null);
    useEffect(() => { function handleClickOutside(event) { if (wrapperRef.current && !wrapperRef.current.contains(event.target)) { setIsOpen(false); setSearchTerm(''); } } document.addEventListener("mousedown", handleClickOutside); return () => document.removeEventListener("mousedown", handleClickOutside); }, [wrapperRef]);
    const handleToggleOption = (optionValue) => { onChange(optionValue); };
    const getTriggerLabel = () => { if (!value || value.length === 0) return defaultLabel; if (value.length === 1) { const selected = options.find(opt => opt.value === value[0]); return selected ? selected.label : (typeof value[0] === 'string' ? value[0].replace(/_/g, ' ') : ''); } return `${value.length} Selected`; };
    const filteredOptions = options.filter(option => (option.label || '').toLowerCase().includes(searchTerm.toLowerCase()));
    return (<div className="custom-select-wrapper" ref={wrapperRef} onMouseEnter={() => setIsOpen(true)} onMouseLeave={() => setIsOpen(false)}><div className="custom-select-trigger">{icon}<span>{getTriggerLabel()}</span><IoChevronDown className={`arrow ${isOpen ? 'open' : ''}`} /></div>{isOpen && (<div className="custom-options"><div className="custom-options-search"><IoSearchOutline /><input type="text" placeholder="Search..." value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} autoFocus onClick={e => e.stopPropagation()} /></div>{filteredOptions.length > 0 ? (filteredOptions.map(option => (<div key={option.value} className={`custom-option ${value.includes(option.value) ? 'selected' : ''}`} onClick={() => handleToggleOption(option.value)}><input type="checkbox" checked={value.includes(option.value)} readOnly /><label>{option.label}</label></div>))) : (<div className="custom-option-message">No results found</div>)}</div>)}</div>);
};

const SubtaskList = ({ parentTaskId, subtaskData, navigate, isSuperAdmin, onTaskDelete }) => {
    const [expandedComments, setExpandedComments] = useState({});
    const isVisible = subtaskData && subtaskData.isVisible;
    if (!isVisible) return null;
    if (subtaskData.isLoading) { return <div className="subtasks-professional-container"><div className="subtask-item-empty">Loading Subtasks...</div></div>; }
    const handleToggleComment = (taskId) => { setExpandedComments(prev => ({ ...prev, [taskId]: !prev[taskId] })); };
    const formatDate = (dateString) => { if (!dateString) return 'N/A'; return new Date(dateString).toLocaleDateString('en-GB', { day: '2-digit', month: 'short' }); };
    return (<div className="subtasks-professional-container"><div className="subtask-professional-header"><span>Task</span><span>Assignee</span><span>Due Date</span><span>Priority</span><span>Status</span><span title="Latest Comment"><IoChatbubbleEllipsesOutline /></span><span>Actions</span></div><div className="subtask-professional-body">{subtaskData.tasks.length > 0 ? (subtaskData.tasks.map(subtask => { const latestCommentInfo = (() => { if (!subtask.comments || !Array.isArray(subtask.comments) || subtask.comments.length === 0) return null; const firstValidComment = subtask.comments.find(c => c && typeof c === 'string' && c.trim() !== '' && !c.includes('| reason :')); if (!firstValidComment) return null; const match = firstValidComment.match(/Comment by (.*?):/i); const author = match ? match[1] : 'System'; const text = firstValidComment.replace(/Comment by.*?:/i, '').trim(); return { author, text }; })(); const isCommentExpanded = !!expandedComments[subtask.taskId]; return (<div className="subtask-item-wrapper" key={subtask.taskId}><div className={`subtask-professional-row ${isCommentExpanded ? 'is-comment-expanded' : ''}`}><div className="subtask-cell-main-content" onClick={() => navigate(`/tasks/${subtask.taskId}`, { state: { task: subtask } })}><div className="subtask-cell-title"><span className="subtask-id">#{subtask.taskId}</span><span className="subtask-title">{subtask.title}</span></div><div className="subtask-cell-assignee"><UserProfileImage userName={subtask.assigneeName} className="user-avatar-subtask" /><span>{subtask.assigneeName || 'Unassigned'}</span></div><div className="subtask-cell-date"><IoCalendarOutline /><span>{formatDate(subtask.dueDate)}</span></div><div className="subtask-cell-priority">{subtask.priority && (<div className={`priority-badge priority-${subtask.priority.toLowerCase()}`}><IoFlagOutline /> {subtask.priority}</div>)}</div><div className="subtask-cell-status"><div className={`task-status-badge status-${getStatusClass(subtask.status)}`}>{subtask.status ? subtask.status.replace(/_/g, ' ') : 'None'}</div></div></div><div className="subtask-cell-comment" onClick={(e) => { e.stopPropagation(); if (latestCommentInfo) handleToggleComment(subtask.taskId); }}>{latestCommentInfo && <IoChatbubbleEllipsesOutline className="comment-indicator-icon" />}</div><div className="subtask-cell-actions">{isSuperAdmin && (<button onClick={(e) => { e.stopPropagation(); onTaskDelete(subtask.taskId, parentTaskId); }} className="action-btn delete-btn" title="Delete Subtask"><IoTrashOutline size={16} /></button>)}</div></div><div className={`subtask-comment-section ${isCommentExpanded ? 'visible' : ''}`}>{latestCommentInfo && (<><div className="comment-author">Latest Comment by {latestCommentInfo.author}</div><p className="comment-text">{latestCommentInfo.text}</p></>)}</div></div>); })) : (<div className="subtask-item-empty">No subtasks found for this task.</div>)}</div></div>);
};

const TaskCard = ({ item, isSuperAdmin, onTaskDelete, onCloneTask, onTaskSubtask, companyKeyword, onToggleSubtasks, subtaskData, index, viewMode, isTargetTask, isTagged }) => {
    const { task, user } = item;
    const navigate = useNavigate();
    const cardRef = useRef(null);
    const isSubtasksVisible = subtaskData && subtaskData.isVisible;

    useEffect(() => {
        if (isTargetTask && cardRef.current) {
            cardRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
            // Add a temporary highlight animation class manually if needed, or rely on 'highlighted' class prop 
        }
    }, [isTargetTask]);

    const latestCommentInfo = useMemo(() => { if (!task.comments || !Array.isArray(task.comments) || task.comments.length === 0) return null; const firstValidComment = task.comments.find(c => c && typeof c === 'string' && c.trim() !== '' && !c.includes('| reason :')); if (!firstValidComment) return null; const match = firstValidComment.match(/Comment by (.*?):/i); const author = match ? match[1] : 'System'; const commentText = firstValidComment.replace(/Comment by.*?:/i, '').trim(); return { author, text: commentText }; }, [task.comments]);
    const overdueInfo = useMemo(() => { if (task.status?.toLowerCase() === 'completed' || !task.dueDate) return null; if (task.remainingTime && task.remainingTime.includes('-')) { const cleanedTime = task.remainingTime.replace(/-/g, '').trim(); return { text: `Overdue by`, remainingTime: cleanedTime }; } const now = new Date(); const dueDate = new Date(task.dueDate); if (dueDate < now) return { text: 'Overdue', remainingTime: '' }; return null; }, [task.dueDate, task.status, task.remainingTime]);
    const formatDateTime = (dateString) => { if (!dateString) return null; return new Date(dateString).toLocaleString('en-GB', { day: 'numeric', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit', hour12: false }).replace(',', ''); };
    const createdDate = useMemo(() => formatDateTime(task.createdAt), [task.createdAt]);
    const dueDate = useMemo(() => formatDateTime(task.dueDate), [task.dueDate]);
    const completedDate = useMemo(() => task.status?.toLowerCase() === 'completed' ? formatDateTime(task.completedAt) : null, [task.status, task.completedAt]);
    const renderDueDate = () => (<div className="meta-item-date"><IoCalendarOutline /> Due: {dueDate}{overdueInfo && (<span className="overdue-badge" style={{ marginLeft: '8px', padding: '2px 6px' }}><IoWarningOutline /> {overdueInfo.text} {overdueInfo.remainingTime}</span>)}</div>);
    const cardClassName = `task-card-wrapper ${isTargetTask ? 'highlighted' : ''}`;
    const taskCardClassName = `task-card ${isSubtasksVisible && viewMode !== 'grid' ? 'is-expanded' : ''} ${companyKeyword !== 'PL' && task.no_of_sub_tasks > 0 ? 'has-subtasks' : ''} ${isTagged ? 'is-tagged' : ''}`;

    const completionHoverText = task.status?.toLowerCase() === 'completed' && task.completedAt
        ? `Completed on: ${new Date(task.completedAt).toLocaleString('en-GB', { day: 'numeric', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' })}`
        : task.status?.replace(/_/g, ' ');

    if (viewMode === 'list') { return (<div className={cardClassName}><div className={taskCardClassName} style={{ animationDelay: `${index * 50}ms` }} ref={cardRef}><div className="task-content-area" onClick={() => navigate(`/tasks/${task.taskId}`, { state: { task } })}><div className="task-card-header"><h3 className="task-title">{task.title} <span className="task-id-badge">#{task.taskId}</span></h3>{task.status && <div className={`task-status-badge status-${getStatusClass(task.status)}`} title={completionHoverText}>{task.status.replace(/_/g, ' ')}</div>}</div><div className="task-project-customer-row">{task.projectName && <div className="task-project-badge"><IoBriefcaseOutline /> {task.projectName}</div>}{task.customerName && <div className="task-customer-badge"><IoBusinessOutline /> {task.customerName}</div>}</div><div className="task-card-footer"><div className="footer-meta-items">{task.priority && <div className={`priority-badge priority-${task.priority.toLowerCase()}`}><IoFlagOutline /> {task.priority}</div>}{companyKeyword !== 'PL' && task.no_of_sub_tasks > 0 && (<div className="meta-item-subtasks" title={`${task.no_of_sub_tasks} subtasks`}><IoGitNetworkOutline /> {task.no_of_sub_tasks}</div>)}{task.category && <div className="meta-item-category"><IoPricetagOutline /> {task.category.replace(/_/g, ' ')}</div>}{task.createdBy && <div className="meta-item-date"><IoPeopleOutline /> Created By: {task.createdBy}</div>}{createdDate && <div className="meta-item-date"><IoCalendarOutline /> Created: {createdDate}</div>}{dueDate && renderDueDate()}{completedDate && <div className="meta-item-date completed"><IoCheckmarkDoneCircleOutline /> Completed: {completedDate}</div>}</div>{latestCommentInfo && (<div className="comment-indicator" title="Latest Comment"><IoChatbubbleEllipsesOutline /></div>)}</div></div>{latestCommentInfo && (<div className="comment-section"><div className="comment-author">Latest Comment by {latestCommentInfo.author}</div><p className="comment-text">{latestCommentInfo.text}</p></div>)}<div className="grid-card-user-info">{companyKeyword === 'ZO' && !task.parentTaskId && (<button onClick={() => onToggleSubtasks(task.taskId)} className="action-btn subtask-toggle-btn" title="View Subtasks"><IoChevronDown style={{ transform: isSubtasksVisible ? 'rotate(180deg)' : 'rotate(0deg)' }} /></button>)}<UserProfileImage userName={user.name} className="user-avatar-small" /><span className="user-name-small">{user.name}</span><div className="task-actions">{companyKeyword === 'ZO' && !task.parentTaskId && (<button onClick={(e) => { e.stopPropagation(); onTaskSubtask(task); }} className="action-btn subtask-btn" title="Create Subtask"><IoGitNetworkOutline size={16} /></button>)}<button onClick={(e) => { e.stopPropagation(); onCloneTask(task); }} className="action-btn clone-btn" title="Clone Task"><IoCopyOutline size={16} /></button>{isSuperAdmin && (<button onClick={(e) => { e.stopPropagation(); onTaskDelete(task.taskId); }} className="action-btn delete-btn" title="Delete Task"><IoTrashOutline size={16} /></button>)}</div></div></div>{companyKeyword !== 'PL' && <SubtaskList parentTaskId={task.taskId} subtaskData={subtaskData} navigate={navigate} isSuperAdmin={isSuperAdmin} onTaskDelete={onTaskDelete} />}</div>); }
    return (<div className={cardClassName}><div className={taskCardClassName} style={{ animationDelay: `${index * 50}ms` }} ref={cardRef}><div className="task-content-area" onClick={() => navigate(`/tasks/${task.taskId}`, { state: { task } })}><div className="task-card-header"><h3 className="task-title">{task.title} <span className="task-id-badge">#{task.taskId}</span></h3>{task.status && <div className={`task-status-badge status-${getStatusClass(task.status)}`} title={completionHoverText}>{task.status.replace(/_/g, ' ')}</div>}</div><div className="task-project-customer-row">{task.projectName && <div className="task-project-badge"><IoBriefcaseOutline /> {task.projectName}</div>}{task.customerName && <div className="task-customer-badge"><IoBusinessOutline /> {task.customerName}</div>}</div>{task.description && <p className="task-description">{task.description}</p>}<div className="task-card-footer"><div className="footer-meta-items">{task.priority && <div className={`priority-badge priority-${task.priority.toLowerCase()}`}><IoFlagOutline /> {task.priority}</div>}{companyKeyword !== 'PL' && task.no_of_sub_tasks > 0 && (<div className="meta-item-subtasks" title={`${task.no_of_sub_tasks} subtasks`}><IoGitNetworkOutline /> {task.no_of_sub_tasks}</div>)}{task.category && <div className="meta-item-category"><IoPricetagOutline /> {task.category.replace(/_/g, ' ')}</div>}{task.createdBy && <div className="meta-item-date"><IoPeopleOutline /> Created By: {task.createdBy}</div>}{createdDate && <div className="meta-item-date"><IoCalendarOutline /> Created: {createdDate}</div>}{dueDate && renderDueDate()}{completedDate && <div className="meta-item-date completed"><IoCheckmarkDoneCircleOutline /> Completed: {completedDate}</div>}</div>{latestCommentInfo && (<div className="comment-indicator" title="Latest Comment"><IoChatbubbleEllipsesOutline /></div>)}</div></div>{latestCommentInfo && (<div className="comment-section"><div className="comment-author">Latest Comment by {latestCommentInfo.author}</div><p className="comment-text">{latestCommentInfo.text}</p></div>)}<div className="grid-card-user-info">{companyKeyword === 'ZO' && !task.parentTaskId && viewMode !== 'grid' && (<button onClick={() => onToggleSubtasks(task.taskId)} className="action-btn subtask-toggle-btn" title="View Subtasks"><IoChevronDown style={{ transform: isSubtasksVisible ? 'rotate(180deg)' : 'rotate(0deg)' }} /></button>)}<UserProfileImage userName={user.name} className="user-avatar-small" /><span className="user-name-small">{user.name}</span><div className="task-actions">{companyKeyword === 'ZO' && !task.parentTaskId && (<button onClick={(e) => { e.stopPropagation(); onTaskSubtask(task); }} className="action-btn subtask-btn" title="Create Subtask"><IoGitNetworkOutline size={16} /></button>)}<button onClick={(e) => { e.stopPropagation(); onCloneTask(task); }} className="action-btn clone-btn" title="Clone Task"><IoCopyOutline size={16} /></button>{isSuperAdmin && (<button onClick={(e) => { e.stopPropagation(); onTaskDelete(task.taskId); }} className="action-btn delete-btn" title="Delete Task"><IoTrashOutline size={16} /></button>)}</div></div></div>{companyKeyword !== 'PL' && viewMode !== 'grid' && <SubtaskList parentTaskId={task.taskId} subtaskData={subtaskData} navigate={navigate} isSuperAdmin={isSuperAdmin} onTaskDelete={onTaskDelete} />}</div>);
};

const TaskCompactListItem = ({ item, isSuperAdmin, onTaskDelete, onCloneTask, onTaskSubtask, companyKeyword, index, isTargetTask, onToggleSubtasks, subtaskData, navigate, isTagged }) => {
    const { task, user } = item;
    const itemRef = useRef(null);
    const isSubtasksVisible = subtaskData && subtaskData.isVisible;

    useEffect(() => {
        if (isTargetTask && itemRef.current) {
            itemRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
    }, [isTargetTask]);

    const formatDate = (dateString) => { if (!dateString) return null; return new Date(dateString).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' }); };
    const dueDate = formatDate(task.dueDate);
    const itemClassName = `task-compact-list-item ${isTargetTask ? 'highlighted' : ''} ${isSubtasksVisible ? 'is-expanded' : ''} ${companyKeyword !== 'PL' && task.no_of_sub_tasks > 0 ? 'has-subtasks' : ''} ${isTagged ? 'is-tagged' : ''}`;
    const handleNavigate = () => { navigate(`/tasks/${task.taskId}`); };

    const completionHoverText = task.status?.toLowerCase() === 'completed' && task.completedAt
        ? `Completed on: ${new Date(task.completedAt).toLocaleString('en-GB', { day: 'numeric', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' })}`
        : task.status?.replace(/_/g, ' ');

    return (<div className={itemClassName} style={{ animationDelay: `${index * 30}ms` }} ref={itemRef} onClick={handleNavigate}><div className="task-compact-list-id-section">#{task.taskId}</div><div className="task-compact-list-title-section"><span className="task-title">{task.title}</span></div><div className="task-compact-list-project-section">{task.projectName && (<div className="meta-badge project-badge" title={task.projectName}><IoBriefcaseOutline /><span>{task.projectName}</span></div>)}</div><div className="task-compact-list-customer-section">{task.customerName && (<div className="meta-badge customer-badge" title={task.customerName}><IoBusinessOutline /><span>{task.customerName}</span></div>)}</div>{companyKeyword !== 'PL' && (<div className="task-compact-list-subtask-section">{task.no_of_sub_tasks > 0 && (<div className="meta-badge subtask-badge" title={`${task.no_of_sub_tasks} subtasks`}><IoGitNetworkOutline /><span>{task.no_of_sub_tasks}</span></div>)}</div>)}<div className="task-compact-list-category-section">{task.category && (<div className="meta-badge category-badge" title={task.category.replace(/_/g, ' ')}><IoPricetagOutline /><span>{task.category.replace(/_/g, ' ')}</span></div>)}</div><div className="task-compact-list-priority-section">{task.priority && (<div className={`meta-badge priority-badge priority-${task.priority.toLowerCase()}`}><IoFlagOutline /><span>{task.priority}</span></div>)}</div><div className="task-compact-list-status-section">{task.status && (<div className={`meta-badge status-badge status-${getStatusClass(task.status)}`} title={completionHoverText}><span>{task.status.replace(/_/g, ' ')}</span></div>)}</div><div className="task-compact-list-date-section">{dueDate && (<div className="meta-badge date-badge"><IoCalendarOutline /><span>{dueDate}</span></div>)}</div><div className="task-compact-list-user-section"><UserProfileImage userName={user.name} className="user-avatar-small" /><span className="user-name" title={user.name}>{user.name}</span></div><div className="task-compact-list-actions">{companyKeyword === 'ZO' && !task.parentTaskId && (<button onClick={(e) => { e.stopPropagation(); onToggleSubtasks(task.taskId); }} className="action-btn subtask-toggle-btn" title="View Subtasks"><IoChevronDown style={{ transform: isSubtasksVisible ? 'rotate(180deg)' : 'rotate(0deg)' }} /></button>)}{companyKeyword === 'ZO' && !task.parentTaskId && (<button onClick={(e) => { e.stopPropagation(); onTaskSubtask(task); }} className="action-btn subtask-btn" title="Create Subtask"><IoGitNetworkOutline size={16} /></button>)}<button onClick={(e) => { e.stopPropagation(); onCloneTask(task); }} className="action-btn clone-btn" title="Clone Task"><IoCopyOutline size={16} /></button>{isSuperAdmin && (<button onClick={(e) => { e.stopPropagation(); onTaskDelete(task.taskId); }} className="action-btn delete-btn" title="Delete Task"><IoTrashOutline size={16} /></button>)}</div></div>);
};

const UserNode = ({ node, isSuperAdmin, onTaskDelete, onCloneTask, onTaskSubtask, companyKeyword, onToggleSubtasks, expandedSubtasks, depth = 0, targetTaskId, filters, taggedTaskIds }) => {
    const isInitiallyExpanded = useMemo(() => { if (targetTaskId && (node.tasks || []).some(t => String(t.taskId) === String(targetTaskId))) return true; return false; }, [node.tasks, targetTaskId]);
    const [isExpanded, setIsExpanded] = useState(isInitiallyExpanded);
    const taskRefs = useRef({});
    useEffect(() => { setIsExpanded(isInitiallyExpanded); }, [isInitiallyExpanded]);

    useEffect(() => {
        if (targetTaskId && isExpanded && taskRefs.current[targetTaskId]) {
            taskRefs.current[targetTaskId].scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
    }, [isExpanded, targetTaskId]);

    const filteredTasks = useMemo(() => (node.tasks || []).filter(task => taskMatchesFilters(task, node, filters)).sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt)), [node, filters]);
    const hasTasks = filteredTasks.length > 0;
    const hasVisibleChildren = (node.children || []).some(child => nodeHasVisibleContent(child, filters));
    const handleToggle = () => { if (hasTasks) setIsExpanded(!isExpanded); };
    if (!hasTasks && !hasVisibleChildren) { return null; }
    return (<div className="user-node" style={{ paddingLeft: `${depth * 25}px` }}><div className="user-header" onClick={handleToggle} style={{ cursor: hasTasks ? 'pointer' : 'default' }}><span className="user-node-toggle-icon">{hasTasks ? (<IoChevronDown style={{ transform: isExpanded ? 'rotate(0deg)' : 'rotate(-90deg)', transition: 'transform 0.2s' }} />) : (<span style={{ width: '1.25rem', display: 'inline-block' }}></span>)}</span><UserProfileImage userName={node.name} className="user-avatar" /><div><div className="user-name">{node.name}</div><div className="user-designation">{node.designation || 'N/A'}</div></div></div>{isExpanded && hasTasks && (<div className="node-body"><div className="tasks-list-view-container">{filteredTasks.map((task, taskIndex) => (<div key={task.taskId} ref={(el) => (taskRefs.current[task.taskId] = el)}><TaskCard item={{ task, user: node }} isSuperAdmin={isSuperAdmin} onTaskDelete={onTaskDelete} onCloneTask={onCloneTask} onTaskSubtask={onTaskSubtask} companyKeyword={companyKeyword} onToggleSubtasks={onToggleSubtasks} subtaskData={expandedSubtasks[task.taskId]} index={taskIndex} viewMode="list" isTargetTask={targetTaskId && String(task.taskId) === String(targetTaskId)} isTagged={taggedTaskIds.has(task.taskId)} /></div>))}</div></div>)}{hasVisibleChildren && (<div className="children-nodes">{node.children.map(child => (<UserNode key={child.id} node={child} isSuperAdmin={isSuperAdmin} onTaskDelete={onTaskDelete} onCloneTask={onCloneTask} onTaskSubtask={onTaskSubtask} companyKeyword={companyKeyword} onToggleSubtasks={onToggleSubtasks} expandedSubtasks={expandedSubtasks} depth={depth + 1} targetTaskId={targetTaskId} filters={filters} taggedTaskIds={taggedTaskIds} />))}</div>)}</div>);
};

const Modal = ({ isOpen, onClose, title, children }) => { const modalRef = useRef(); useOutsideAlerter(modalRef, onClose); if (!isOpen) return null; return (<div className="template-modal-overlay"><div className="template-modal" ref={modalRef}><div className="template-modal-header"><h3>{title}</h3><button onClick={onClose} className="close-modal-btn"><IoClose /></button></div><div className="template-modal-body">{children}</div></div></div>); };

const ConfirmationModal = ({ isOpen, onClose, onConfirm, title, children }) => {
    const modalRef = useRef();
    useOutsideAlerter(modalRef, onClose);
    if (!isOpen) return null;
    return (
        <div className="confirmation-modal-overlay">
            <div className="confirmation-modal" ref={modalRef}>
                <div className="confirmation-modal-header">
                    <h3>{title}</h3>
                    <button onClick={onClose} className="close-modal-btn"><IoClose /></button>
                </div>
                <div className="confirmation-modal-body">
                    {children}
                </div>
                <div className="confirmation-modal-footer">
                    <button onClick={onClose} className="confirm-btn cancel">Cancel</button>
                    <button onClick={onConfirm} className="confirm-btn confirm">Delete</button>
                </div>
            </div>
        </div>
    );
};

const AssignDraftModal = ({ isOpen, onClose, onConfirm, users, title }) => {
    const modalRef = useRef();
    const [selectedUserId, setSelectedUserId] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');

    useOutsideAlerter(modalRef, onClose);

    useEffect(() => {
        if (isOpen) {
            setSelectedUserId(null);
            setSearchTerm('');
        }
    }, [isOpen]);

    const filteredUsers = useMemo(() => {
        if (!searchTerm) return users;
        const lowercasedFilter = searchTerm.toLowerCase();
        return users.filter(user =>
            user.name.toLowerCase().includes(lowercasedFilter)
        );
    }, [users, searchTerm]);

    const handleConfirm = () => {
        if (selectedUserId) {
            onConfirm(selectedUserId);
        }
    };

    if (!isOpen) return null;

    return (
        <div className="confirmation-modal-overlay assign-modal">
            <div className="confirmation-modal" ref={modalRef} style={{ minWidth: '400px' }}>
                <div className="confirmation-modal-header">
                    <h3>{title}</h3>
                    <button onClick={onClose} className="close-modal-btn"><IoClose /></button>
                </div>
                <div className="confirmation-modal-body">
                    <div className="template-modal-search" style={{ marginBottom: '15px', padding: '0' }}>
                        <IoSearchOutline />
                        <input
                            type="text"
                            placeholder="Search user..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            autoFocus
                        />
                    </div>
                    <div className="user-selection-list">
                        {filteredUsers.length > 0 ? filteredUsers.map(user => (
                            <div
                                key={user.id}
                                className={`user-selection-item ${selectedUserId === user.id ? 'selected' : ''}`}
                                onClick={() => setSelectedUserId(user.id)}
                            >
                                <UserProfileImage userName={user.name} className="user-avatar-small" />
                                <span className="user-name-small">{user.name}</span>
                            </div>
                        )) : <div className="no-results-message">No users found.</div>}
                    </div>
                </div>
                <div className="confirmation-modal-footer">
                    <button onClick={onClose} className="confirm-btn cancel">Cancel</button>
                    <button onClick={handleConfirm} className="confirm-btn confirm" disabled={!selectedUserId}>Assign</button>
                </div>
            </div>
        </div>
    );
};

const TemplatePreviewModal = ({ isOpen, onClose, template }) => {
    const modalRef = useRef();
    const [expandedMainTasks, setExpandedMainTasks] = useState(new Set());

    useOutsideAlerter(modalRef, onClose);

    useEffect(() => {
        setExpandedMainTasks(new Set());
    }, [template]);

    const toggleMainTask = (mainTaskId) => {
        setExpandedMainTasks(prev => {
            const newSet = new Set(prev);
            if (newSet.has(mainTaskId)) {
                newSet.delete(mainTaskId);
            } else {
                newSet.add(mainTaskId);
            }
            return newSet;
        });
    };

    if (!isOpen || !template) return null;

    return (
        <div className="preview-modal-overlay">
            <div className="preview-modal" ref={modalRef}>
                <div className="template-modal-header">
                    <h3><IoDocumentsOutline /> Preview: {template.projectTemplateName}</h3>
                    <button onClick={onClose} className="close-modal-btn"><IoClose /></button>
                </div>
                <div className="template-preview-body">
                    {template.mainTasks && template.mainTasks.length > 0 ? (
                        <ul className="main-task-list">
                            {template.mainTasks.map(mainTask => {
                                const hasSubtasks = mainTask.subTasks && mainTask.subTasks.length > 0;
                                const isExpanded = expandedMainTasks.has(mainTask.mainTaskId);
                                return (
                                    <li key={mainTask.mainTaskId} className={`main-task-item ${hasSubtasks ? 'has-subtasks' : ''}`}>
                                        <div className="main-task-title" onClick={() => hasSubtasks && toggleMainTask(mainTask.mainTaskId)}>
                                            <IoGitNetworkOutline className="main-task-icon" />
                                            <span>{mainTask.mainTaskTitle}</span>
                                            {hasSubtasks && <IoChevronDown className={`main-task-chevron ${isExpanded ? 'expanded' : ''}`} />}
                                        </div>
                                        {hasSubtasks && (
                                            <div className={`sub-task-container ${isExpanded ? 'expanded' : ''}`}>
                                                <ul className="sub-task-list">
                                                    {mainTask.subTasks.map(subTask => (
                                                        <li key={subTask.subTaskId} className="sub-task-item">
                                                            <IoReturnDownForwardOutline className="sub-task-icon" />
                                                            <span>{subTask.subTaskTitle}</span>
                                                        </li>
                                                    ))}
                                                </ul>
                                            </div>
                                        )}
                                    </li>
                                );
                            })}
                        </ul>
                    ) : (
                        <div className="template-option-message empty">
                            <IoDocumentsOutline />
                            <span>This template has no tasks defined yet.</span>
                        </div>
                    )}
                </div>
                <div className="template-modal-footer">
                    <button onClick={onClose} className="close-preview-btn">Close</button>
                </div>
            </div>
        </div>
    );
};


const TasksListPage = () => {
    const location = useLocation();
    const navigate = useNavigate();

    const [isInitialising, setIsInitialising] = useState(true);
    const [isTasksLoading, setIsTasksLoading] = useState(false);
    const [isLoadingMore, setIsLoadingMore] = useState(false);
    const [hasMore, setHasMore] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const [error, setError] = useState(null);
    const [infoMessage, setInfoMessage] = useState(null);

    const [allScopedTasks, setAllScopedTasks] = useState([]);
    const [fullHierarchy, setFullHierarchy] = useState([]);
    const [allUsers, setAllUsers] = useState([]);
    const [isSuperAdmin, setIsSuperAdmin] = useState(false);
    const [isReportingManager, setIsReportingManager] = useState(false);
    const [companyKeyword, setCompanyKeyword] = useState('');
    const [taggedTaskIds, setTaggedTaskIds] = useState(new Set());
    const [subordinateUsers, setSubordinateUsers] = useState([]);

    // --- Helper for Lazy State Initialization ---
    // This ensures we read sessionStorage BEFORE the first render, preventing default value flash
    const getSavedState = (key, fallback) => {
        try {
            const savedState = sessionStorage.getItem(SESSION_STORAGE_KEY);
            if (savedState) {
                const parsedState = JSON.parse(savedState);
                return parsedState[key] !== undefined ? parsedState[key] : fallback;
            }
        } catch (error) {
            console.error('Error reading session storage', error);
        }
        return fallback;
    };

    // Initialize State using getSavedState for persistence
    const [viewMode, setViewMode] = useState(() => getSavedState('viewMode', 'compact-list'));
    const [searchTerm, setSearchTerm] = useState(() => getSavedState('searchTerm', ''));
    const debouncedSearchTerm = useDebounce(searchTerm, 300);

    const [expandedSubtasks, setExpandedSubtasks] = useState({});
    const [targetTaskId, setTargetTaskId] = useState(null);

    const [filterTaskId, setFilterTaskId] = useState(null);
    const [filterStatus, setFilterStatus] = useState(() => getSavedState('filterStatus', []));
    const [filterPriority, setFilterPriority] = useState(() => getSavedState('filterPriority', []));
    const [filterProjectName, setFilterProjectName] = useState(() => getSavedState('filterProjectName', []));
    const [filterCategory, setFilterCategory] = useState(() => getSavedState('filterCategory', []));
    const [filterUserId, setFilterUserId] = useState(() => getSavedState('filterUserId', []));
    const [filterYear, setFilterYear] = useState(() => getSavedState('filterYear', []));
    const [filterMonth, setFilterMonth] = useState(() => getSavedState('filterMonth', []));
    const [filterDepartment, setFilterDepartment] = useState(() => getSavedState('filterDepartment', []));
    const [filterVendorTypes, setFilterVendorTypes] = useState(() => getSavedState('filterVendorTypes', []));
    const [filterCustomers, setFilterCustomers] = useState(() => getSavedState('filterCustomers', []));
    const [filterSuppliers, setFilterSuppliers] = useState(() => getSavedState('filterSuppliers', []));

    const [dateFilterType, setDateFilterType] = useState(() => getSavedState('dateFilterType', 'none'));
    const [dateFrom, setDateFrom] = useState(() => getSavedState('dateFrom', ''));
    const [dateTo, setDateTo] = useState(() => getSavedState('dateTo', ''));
    const [fromDay, setFromDay] = useState(() => getSavedState('fromDay', currentDay.toString()));
    const [fromMonth, setFromMonth] = useState(() => getSavedState('fromMonth', currentMonth.toString()));
    const [fromYear, setFromYear] = useState(() => getSavedState('fromYear', currentYear.toString()));
    const [toDay, setToDay] = useState(() => getSavedState('toDay', currentDay.toString()));
    const [toMonth, setToMonth] = useState(() => getSavedState('toMonth', currentMonth.toString()));
    const [toYear, setToYear] = useState(() => getSavedState('toYear', currentYear.toString()));
    
    const [daysInFromMonth, setDaysInFromMonth] = useState([]);
    const [daysInToMonth, setDaysInToMonth] = useState([]);

    const [masterVendorTypes, setMasterVendorTypes] = useState([]);
    const [masterCustomers, setMasterCustomers] = useState([]);
    const [masterSuppliers, setMasterSuppliers] = useState([]);

    const [projectTemplates, setProjectTemplates] = useState([]);
    const [isTemplateSelectionModalOpen, setIsTemplateSelectionModalOpen] = useState(false);
    const [templateError, setTemplateError] = useState(null);
    const [isDraftSelectionModalOpen, setIsDraftSelectionModalOpen] = useState(false);
    const [isCheckingForDrafts, setIsCheckingForDrafts] = useState(false);

    const [groupedDrafts, setGroupedDrafts] = useState([]);
    const [expandedTemplateId, setExpandedTemplateId] = useState(null);

    const [isDraftDeleteConfirmOpen, setIsDraftDeleteConfirmOpen] = useState(false);
    const [draftToDelete, setDraftToDelete] = useState(null);

    const [isAssignDraftModalOpen, setIsAssignDraftModalOpen] = useState(false);
    const [draftToAssign, setDraftToAssign] = useState(null);

    const [modalSearchTerm, setModalSearchTerm] = useState('');

    const [isPreviewModalOpen, setIsPreviewModalOpen] = useState(false);
    const [templateToPreview, setTemplateToPreview] = useState(null);

    const handleOpenPreviewModal = (template) => {
        setTemplateToPreview(template);
        setIsPreviewModalOpen(true);
    };

    const handleClosePreviewModal = () => {
        setIsPreviewModalOpen(false);
        setTemplateToPreview(null);
    };

    const handleResetFilters = useCallback(() => {
        setSearchTerm('');
        setFilterStatus([]);
        setFilterPriority([]);
        setFilterProjectName([]);
        setFilterCategory([]);
        setFilterYear([]);
        setFilterMonth([]);
        setFilterDepartment([]);
        setFilterVendorTypes([]);
        setFilterCustomers([]);
        setFilterSuppliers([]);
        setDateFilterType('none');
        setTargetTaskId(null);
        setFilterUserId([]);
        setFilterTaskId(null);
        setFromDay(currentDay.toString());
        setFromMonth(currentMonth.toString());
        setFromYear(currentYear.toString());
        setToDay(currentDay.toString());
        setToMonth(currentMonth.toString());
        setToYear(currentYear.toString());
        setDateFrom('');
        setDateTo('');
        // Clear session storage
        sessionStorage.removeItem(SESSION_STORAGE_KEY);
    }, []);

    // --- SAVE FILTER STATE TO SESSION STORAGE ---
    useEffect(() => {
        const filterState = {
            searchTerm,
            filterStatus,
            filterPriority,
            filterProjectName,
            filterCategory,
            filterUserId,
            filterYear,
            filterMonth,
            filterDepartment,
            filterVendorTypes,
            filterCustomers,
            filterSuppliers,
            dateFilterType,
            dateFrom,
            dateTo,
            fromDay,
            fromMonth,
            fromYear,
            toDay,
            toMonth,
            toYear,
            viewMode
        };
        sessionStorage.setItem(SESSION_STORAGE_KEY, JSON.stringify(filterState));
    }, [searchTerm, filterStatus, filterPriority, filterProjectName, filterCategory, filterUserId,
        filterYear, filterMonth, filterDepartment, filterVendorTypes, filterCustomers, filterSuppliers,
        dateFilterType, dateFrom, dateTo, fromDay, fromMonth, fromYear, toDay, toMonth, toYear, viewMode]);

    // --- EFFECT TO HANDLE REDIRECTION FILTERS FROM DASHBOARD & RETURN FROM DETAILS ---
    useEffect(() => {
        const state = location.state || {};
        const { initialFilter, targetTaskId: returnedTaskId } = state;

        if (initialFilter) {
            handleResetFilters();

            if (initialFilter.taskId) {
                setFilterTaskId(String(initialFilter.taskId));
                setTargetTaskId(String(initialFilter.taskId));
            }

            if (initialFilter.userId) {
                if (Array.isArray(initialFilter.userId)) {
                    setFilterUserId(initialFilter.userId.map(String));
                } else {
                    setFilterUserId([String(initialFilter.userId)]);
                }
            }

            if (initialFilter.status) {
                if (Array.isArray(initialFilter.status)) {
                    setFilterStatus(initialFilter.status.map(normalizeForComparison));
                } else {
                    setFilterStatus([normalizeForComparison(initialFilter.status)]);
                }
            }
            if (initialFilter.priority) {
                if (Array.isArray(initialFilter.priority)) {
                    setFilterPriority(initialFilter.priority.map(normalizeForComparison));
                } else {
                    setFilterPriority([normalizeForComparison(initialFilter.priority)]);
                }
            }
            if (initialFilter.projectName) {
                if (Array.isArray(initialFilter.projectName)) {
                    setFilterProjectName(initialFilter.projectName.map(normalizeForComparison));
                } else {
                    setFilterProjectName([normalizeForComparison(initialFilter.projectName)]);
                }
            }
            if (initialFilter.category) {
                if (Array.isArray(initialFilter.category)) {
                    setFilterCategory(initialFilter.category.map(normalizeForComparison));
                } else {
                    setFilterCategory([normalizeForComparison(initialFilter.category)]);
                }
            }
            if (initialFilter.department) {
                if (Array.isArray(initialFilter.department)) {
                    setFilterDepartment(initialFilter.department);
                } else {
                    setFilterDepartment([normalizeForComparison(initialFilter.department)]);
                }
            }
            if (initialFilter.vendorTypes) {
                if (Array.isArray(initialFilter.vendorTypes)) {
                    setFilterVendorTypes(initialFilter.vendorTypes.map(String));
                } else {
                    setFilterVendorTypes([String(initialFilter.vendorTypes)]);
                }
            }
            if (initialFilter.customers) {
                if (Array.isArray(initialFilter.customers)) {
                    setFilterCustomers(initialFilter.customers.map(String));
                } else {
                    setFilterCustomers([String(initialFilter.customers)]);
                }
            }
            if (initialFilter.suppliers) {
                if (Array.isArray(initialFilter.suppliers)) {
                    setFilterSuppliers(initialFilter.suppliers.map(String));
                } else {
                    setFilterSuppliers([String(initialFilter.suppliers)]);
                }
            }
            if (initialFilter.year) {
                if (Array.isArray(initialFilter.year)) {
                    setFilterYear(initialFilter.year.map(String));
                } else {
                    setFilterYear([String(initialFilter.year)]);
                }
            }
            if (initialFilter.month) {
                if (Array.isArray(initialFilter.month)) {
                    setFilterMonth(initialFilter.month.map(String));
                } else {
                    setFilterMonth([String(initialFilter.month)]);
                }
            }

            navigate(location.pathname, { replace: true, state: {} });
        } else if (returnedTaskId) {
            // Returning from task detail page - filters are already restored from session storage via lazy initialization
            setTargetTaskId(String(returnedTaskId));
            navigate(location.pathname, { replace: true, state: {} });
        }
    }, [location.state, navigate, handleResetFilters]);

    useEffect(() => {
        if (filterTaskId) {
            if (debouncedSearchTerm || filterStatus.length || filterPriority.length || filterProjectName.length || filterCategory.length || filterUserId.length || filterYear.length || filterMonth.length || filterDepartment.length || filterVendorTypes.length || filterCustomers.length || filterSuppliers.length || dateFilterType !== 'none') {
                setFilterTaskId(null);
            }
        }
    }, [debouncedSearchTerm, filterStatus, filterPriority, filterProjectName, filterCategory, filterUserId, filterYear, filterMonth, filterDepartment, filterVendorTypes, filterCustomers, filterSuppliers, dateFilterType, filterTaskId]);

    const fetchTasksByPage = useCallback(async (page, userIds) => { if (!userIds || userIds.length === 0) return []; const taskPromises = userIds.map(id => getTasksByUserIdAPI(id, page, TASKS_PER_PAGE)); const tasksForAllUsers = await Promise.all(taskPromises); return tasksForAllUsers.flat(); }, []);

    const filters = useMemo(() => ({ taskId: filterTaskId, searchTerm: debouncedSearchTerm, status: filterStatus, priority: filterPriority, projectName: filterProjectName, userId: filterUserId, category: filterCategory, year: filterYear, month: filterMonth, dateFilterType, dateFrom, dateTo, department: filterDepartment, vendorTypes: filterVendorTypes, customers: filterCustomers, suppliers: filterSuppliers }), [filterTaskId, debouncedSearchTerm, filterStatus, filterPriority, filterProjectName, filterUserId, filterCategory, filterYear, filterMonth, dateFilterType, dateFrom, dateTo, filterDepartment, filterVendorTypes, filterCustomers, filterSuppliers]);

    useEffect(() => { const maxDays = getDaysInMonth(fromYear, fromMonth); setDaysInFromMonth(Array.from({ length: maxDays }, (_, i) => (i + 1).toString())); if (parseInt(fromDay, 10) > maxDays) { setFromDay(maxDays.toString()); } }, [fromYear, fromMonth, fromDay]);
    useEffect(() => { const maxDays = getDaysInMonth(toYear, toMonth); setDaysInToMonth(Array.from({ length: maxDays }, (_, i) => (i + 1).toString())); if (parseInt(toDay, 10) > maxDays) { setToDay(maxDays.toString()); } }, [toYear, toMonth, toDay]);
    
    // NOTE: Removed the useEffect that forced setToDay(fromDay), as this prevented range selection and caused resets on reload.
    
    useEffect(() => { if (dateFilterType !== 'none') { setDateFrom(`${fromYear}-${pad(fromMonth)}-${pad(fromDay)}`); setDateTo(`${toYear}-${pad(toMonth)}-${pad(toDay)}`); } else { setDateFrom(''); setDateTo(''); } }, [fromDay, fromMonth, fromYear, toDay, toMonth, toYear, dateFilterType]);

    const handleMultiSelectChange = (setter) => (value) => { setter(prev => { const newValues = new Set(prev); if (newValues.has(value)) { newValues.delete(value); } else { newValues.add(value); } return [...newValues]; }); };
    const handleSearchChange = (e) => setSearchTerm(e.target.value);
    const handleStatusChange = handleMultiSelectChange(setFilterStatus);
    const handlePriorityChange = handleMultiSelectChange(setFilterPriority);
    const handleProjectChange = handleMultiSelectChange(setFilterProjectName);
    const handleCategoryChange = handleMultiSelectChange(setFilterCategory);
    const handleUserChange = handleMultiSelectChange(setFilterUserId);
    const handleYearChange = handleMultiSelectChange(setFilterYear);
    const handleMonthChange = handleMultiSelectChange(setFilterMonth);
    const handleDepartmentChange = handleMultiSelectChange(setFilterDepartment);
    const handleDateTypeChange = (e) => setDateFilterType(e.target.value);
    const handleVendorTypesChange = handleMultiSelectChange(setFilterVendorTypes);
    const handleCustomersChange = handleMultiSelectChange(setFilterCustomers);
    const handleSuppliersChange = handleMultiSelectChange(setFilterSuppliers);

    useEffect(() => {
        const initialisePage = async () => {
            setIsInitialising(true);
            setError(null);
            try {
                const user = getLoggedInUser();
                if (!user || !user.id) throw new Error("User not authenticated.");

                const userRole = user.role?.name?.toUpperCase();
                setIsSuperAdmin(userRole === 'SUPER_ADMIN');
                setIsReportingManager(userRole === 'REPORTING MANAGER');

                const companyData = await getCompanyDetailsAPI();
                const currentCompanyKeyword = companyData?.message?.[0]?.companyKeyword || '';
                setCompanyKeyword(currentCompanyKeyword);

                const promises = [getUsers(), fetchHierarchyAPI(), getCustomersAPI(), getCommonMasterColumnAPI('vendor_type'), getTaggedTasksAPI()];
                if (currentCompanyKeyword === 'ZO') {
                    const projectTemplatesPromise = getProjectTemplatesAPI().catch(err => {
                        console.error("Non-critical error fetching project templates:", err.message);
                        return [];
                    });
                    promises.push(projectTemplatesPromise);
                }
                const results = await Promise.all(promises);
                const [usersData, hierarchyData, customersData, vendorTypesData, taggedIds] = results;
                const templatesData = currentCompanyKeyword === 'ZO' ? results[5] : [];

                const activeUsers = usersData.filter(u => u.active === true);
                setAllUsers(activeUsers);
                const activeHierarchy = filterActiveHierarchy(hierarchyData);
                setFullHierarchy(activeHierarchy);
                setMasterVendorTypes(vendorTypesData);
                setProjectTemplates(templatesData);
                setTaggedTaskIds(new Set(taggedIds));

                if (userRole === 'REPORTING MANAGER' || userRole === 'SUPER_ADMIN') {
                    const findUserNode = (nodes, userId) => {
                        for (const node of nodes) {
                            if (node.id === userId) return node;
                            const found = findUserNode(node.children || [], userId);
                            if (found) return found;
                        }
                        return null;
                    };
                    const userNode = findUserNode(activeHierarchy, user.id);
                    const subordinateIds = userNode ? getSubordinateIds(userNode) : [user.id];
                    const subordinateUsersList = activeUsers.filter(u => subordinateIds.includes(u.id));
                    setSubordinateUsers(subordinateUsersList);
                }


                const customerTypeId = vendorTypesData.find(vt => vt.value?.toLowerCase() === 'customer')?.id;
                const supplierTypeId = vendorTypesData.find(vt => vt.value?.toLowerCase() === 'supplier')?.id;
                if (customersData.length > 0) {
                    const activeCustomers = customersData.filter(c => c.active);
                    setMasterCustomers(activeCustomers.filter(v => String(v.vendor_type) === String(customerTypeId)));
                    setMasterSuppliers(activeCustomers.filter(v => String(v.vendor_type) === String(supplierTypeId)));
                }
            } catch (err) {
                setError(err.message || 'Failed to load page metadata.');
            } finally {
                setIsInitialising(false);
            }
        };
        initialisePage();
    }, []);

    useEffect(() => {
        if (isInitialising) return;
        const fetchAndSetTasks = async () => {
            setIsTasksLoading(true);
            const user = getLoggedInUser();
            let allowedUserIds = [];

            if (isSuperAdmin) {
                allowedUserIds = allUsers.map(u => String(u.id));
            } else if (user) {
                const findUserNode = (nodes, userId) => {
                    for (const node of nodes) {
                        if (node.id === userId) return node;
                        const found = findUserNode(node.children || [], userId);
                        if (found) return found;
                    }
                    return null;
                };
                const userNode = findUserNode(fullHierarchy, user.id);
                allowedUserIds = (userNode ? getSubordinateIds(userNode) : [user.id]).map(String);
            }

            let userIdsToFetch = [];
            if (filterUserId && filterUserId.length > 0) {
                userIdsToFetch = allowedUserIds.filter(id => filterUserId.includes(id));
            } else {
                userIdsToFetch = allowedUserIds;
            }

            try {
                const initialTasks = await fetchTasksByPage(1, userIdsToFetch);
                setAllScopedTasks(initialTasks);
                setCurrentPage(1);
                setHasMore(initialTasks.length > 0);
            } catch (err) {
                setError(err.message);
                setAllScopedTasks([]);
            } finally {
                setIsTasksLoading(false);
            }
        };
        fetchAndSetTasks();
    }, [isInitialising, isSuperAdmin, allUsers, fullHierarchy, fetchTasksByPage, filterUserId]);

    const handleLoadMore = useCallback(async () => {
        if (isLoadingMore || !hasMore) return;
        setIsLoadingMore(true);
        const nextPage = currentPage + 1;
        const user = getLoggedInUser();

        let allowedUserIds = [];
        if (isSuperAdmin) {
            allowedUserIds = allUsers.map(u => String(u.id));
        } else if (user) {
            const findUserNode = (nodes, userId) => {
                for (const node of nodes) {
                    if (node.id === userId) return node;
                    const found = findUserNode(node.children || [], userId);
                    if (found) return found;
                }
                return null;
            };
            const userNode = findUserNode(fullHierarchy, user.id);
            allowedUserIds = (userNode ? getSubordinateIds(userNode) : [user.id]).map(String);
        }

        let userIdsToFetch = [];
        if (filterUserId && filterUserId.length > 0) {
            userIdsToFetch = allowedUserIds.filter(id => filterUserId.includes(id));
        } else {
            userIdsToFetch = allowedUserIds;
        }

        try {
            const newTasks = await fetchTasksByPage(nextPage, userIdsToFetch);
            if (newTasks.length > 0) {
                setAllScopedTasks(prev => [...prev, ...newTasks]);
                setCurrentPage(nextPage);
            } else {
                setHasMore(false);
            }
        } catch (err) {
            setError('Failed to load more tasks.');
        } finally {
            setIsLoadingMore(false);
        }
    }, [currentPage, hasMore, isLoadingMore, fetchTasksByPage, isSuperAdmin, allUsers, fullHierarchy, filterUserId]);

    const handleTaskDelete = async (taskId, parentId = null) => { const taskType = parentId ? 'subtask' : 'task'; if (!isSuperAdmin || !window.confirm(`Are you sure you want to delete this ${taskType}?`)) return; try { await deleteTaskApi(taskId); if (parentId) { setExpandedSubtasks(prev => { const parentSubtasks = prev[parentId] || { tasks: [] }; const updatedTasks = parentSubtasks.tasks.filter(st => st.taskId !== taskId); return { ...prev, [parentId]: { ...parentSubtasks, tasks: updatedTasks } }; }); setAllScopedTasks(prevTasks => prevTasks.map(pTask => pTask.taskId === parentId ? { ...pTask, no_of_sub_tasks: Math.max(0, (pTask.no_of_sub_tasks || 1) - 1) } : pTask)); } else { setAllScopedTasks(prevTasks => prevTasks.filter(t => t.taskId !== taskId)); } setInfoMessage(`${taskType.charAt(0).toUpperCase() + taskType.slice(1)} deleted successfully.`); setTimeout(() => setInfoMessage(null), 3000); } catch (err) { setError(err.response?.data?.message || `Failed to delete ${taskType}.`); } };
    const handleCloneTask = (taskToClone) => { navigate('/tasks/create', { state: { taskToClone } }); };
    const handleCreateSubtask = (parentTask) => { navigate('/tasks/create', { state: { parentTask, subtaskOnly: true } }); };
    const handleToggleSubtasks = useCallback(async (taskId) => { const existing = expandedSubtasks[taskId]; if (existing?.isVisible) { setExpandedSubtasks(prev => ({ ...prev, [taskId]: { ...existing, isVisible: false } })); return; } if (existing && !existing.isVisible) { setExpandedSubtasks(prev => ({ ...prev, [taskId]: { ...existing, isVisible: true } })); return; } setExpandedSubtasks(prev => ({ ...prev, [taskId]: { isLoading: true, tasks: [], isVisible: true } })); try { const subtasks = await getSubTasksAPI(taskId); setExpandedSubtasks(prev => ({ ...prev, [taskId]: { isLoading: false, tasks: subtasks, isVisible: true } })); } catch (error) { console.error(`Failed to fetch subtasks for task ${taskId}:`, error); setExpandedSubtasks(prev => ({ ...prev, [taskId]: { isLoading: false, tasks: [], isVisible: true, error: error.message } })); } }, [expandedSubtasks]);

    const handleTemplateSelect = (templateId) => {
        setIsTemplateSelectionModalOpen(false);
        navigate('/tasks/create-from-template', { state: { templateIdToLoad: templateId, isEditingDraft: false } });
    };

    const handleEditDraftSelect = (session) => {
        setIsDraftSelectionModalOpen(false);
        navigate('/tasks/create-from-template', {
            state: {
                templateIdToLoad: session.template.projectTemplateId,
                isEditingDraft: true,
                draftTasksToLoad: session.tasks
            }
        });
    };

    const openDeleteDraftConfirm = (session) => {
        setDraftToDelete(session);
        setIsDraftDeleteConfirmOpen(true);
    };

    const confirmDeleteDraft = async () => {
        if (!draftToDelete) return;
        try {
            const deletePromises = draftToDelete.tasks.map(task => deleteDraftTaskApi(task.draftTaskId));
            await Promise.all(deletePromises);

            setGroupedDrafts(prevGrouped => {
                return prevGrouped.map(group => {
                    if (group.template.projectTemplateId === draftToDelete.template.projectTemplateId) {
                        const updatedSessions = group.sessions.filter(session => session.savedAt !== draftToDelete.savedAt);
                        return { ...group, sessions: updatedSessions };
                    }
                    return group;
                }).filter(group => group.sessions.length > 0);
            });

            setInfoMessage("Draft deleted successfully.");
            setTimeout(() => setInfoMessage(null), 3000);
        } catch (err) {
            setTemplateError(err.message || "Failed to delete the draft.");
        } finally {
            setIsDraftDeleteConfirmOpen(false);
            setDraftToDelete(null);
        }
    };

    const openAssignDraftModal = (session) => {
        setDraftToAssign(session);
        setIsAssignDraftModalOpen(true);
    };

    const confirmAssignDraft = async (selectedUserId) => {
        if (!draftToAssign || !selectedUserId) return;
        try {
            const assignPromises = draftToAssign.tasks.map(task => updateDraftAssigneeApi(task.draftTaskId, selectedUserId));
            await Promise.all(assignPromises);

            const newAssignee = allUsers.find(u => u.id === selectedUserId);

            setGroupedDrafts(prevGrouped => {
                return prevGrouped.map(group => {
                    if (group.template.projectTemplateId === draftToAssign.template.projectTemplateId) {
                        const updatedSessions = group.sessions.map(session => {
                            if (session.savedAt === draftToAssign.savedAt) {
                                return { ...session, assigneeName: newAssignee?.name || session.assigneeName };
                            }
                            return session;
                        });
                        return { ...group, sessions: updatedSessions };
                    }
                    return group;
                });
            });

            setInfoMessage(`Draft assigned to ${newAssignee?.name} successfully.`);
            setTimeout(() => setInfoMessage(null), 3000);

        } catch (err) {
            setTemplateError(err.message || "Failed to assign the draft.");
        } finally {
            setIsAssignDraftModalOpen(false);
            setDraftToAssign(null);
        }
    };


    const handleOpenDraftsModal = async () => {
        setModalSearchTerm('');
        setIsDraftSelectionModalOpen(true);
        setIsCheckingForDrafts(true);
        setGroupedDrafts([]);
        setExpandedTemplateId(null);
        setTemplateError(null);
        try {
            const currentUser = getLoggedInUser();
            if (!currentUser || !currentUser.id) {
                throw new Error("Could not identify the current user to filter drafts.");
            }

            const findUserNode = (nodes, userId) => {
                for (const node of nodes) {
                    if (node.id === userId) return node;
                    const found = findUserNode(node.children || [], userId);
                    if (found) return found;
                }
                return null;
            };

            const userNode = findUserNode(fullHierarchy, currentUser.id);
            const subordinateIds = userNode ? getSubordinateIds(userNode) : [currentUser.id];
            const subordinateIdsSet = new Set(subordinateIds.map(id => String(id)));

            const hierarchicalUsers = allUsers.filter(u => subordinateIdsSet.has(String(u.id)));
            const hierarchicalUserNames = new Set(hierarchicalUsers.map(u => u.name));

            const draftPromises = projectTemplates.map(async (template) => {
                const draftData = await getDraftsByTemplateId(template.projectTemplateId);
                return { template, draftTasks: draftData.draft_tasks || [] };
            });

            const results = await Promise.all(draftPromises);

            const draftsByTemplate = [];
            for (const result of results) {
                if (result.draftTasks.length > 0) {
                    const sessions = groupDraftsIntoSessions(result.draftTasks, result.template);
                    const userAndSubordinateSessions = sessions.filter(session => hierarchicalUserNames.has(session.createdBy));
                    if (userAndSubordinateSessions.length > 0) {
                        draftsByTemplate.push({
                            template: result.template,
                            sessions: userAndSubordinateSessions.sort((a, b) => new Date(b.savedAt) - new Date(a.savedAt))
                        });
                    }
                }
            }

            draftsByTemplate.sort((a, b) => a.template.projectTemplateName.localeCompare(b.template.projectTemplateName));
            setGroupedDrafts(draftsByTemplate);

        } catch (err) {
            setTemplateError(err.message || "Could not check for drafts.");
        } finally {
            setIsCheckingForDrafts(false);
        }
    };

    const handleToggleTemplateExpansion = (templateId) => {
        setExpandedTemplateId(prevId => (prevId === templateId ? null : templateId));
    };

    const formatModalDate = (dateString) => {
        if (!dateString) return 'N/A';
        return new Date(dateString).toLocaleString('en-GB', {
            day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit'
        });
    };

    const filteredProjectTemplates = useMemo(() => {
        if (!modalSearchTerm) return projectTemplates;
        const searchTermLower = modalSearchTerm.toLowerCase();
        return projectTemplates.filter(template =>
            template.projectTemplateName.toLowerCase().includes(searchTermLower) ||
            formatModalDate(template.createdAt).toLowerCase().includes(searchTermLower) ||
            formatModalDate(template.updatedAt).toLowerCase().includes(searchTermLower)
        );
    }, [projectTemplates, modalSearchTerm]);

    const filteredGroupedDrafts = useMemo(() => {
        if (!modalSearchTerm) return groupedDrafts;
        const searchTermLower = modalSearchTerm.toLowerCase();
        return groupedDrafts.map(group => {
            const matchingSessions = group.sessions.filter(session =>
                session.displayName.toLowerCase().includes(searchTermLower) ||
                (session.createdBy && session.createdBy.toLowerCase().includes(searchTermLower)) ||
                (session.assigneeName && session.assigneeName.toLowerCase().includes(searchTermLower)) ||
                formatModalDate(session.savedAt).toLowerCase().includes(searchTermLower)
            );
            const templateNameMatches = group.template.projectTemplateName.toLowerCase().includes(searchTermLower);
            if (templateNameMatches) {
                return group;
            } else if (matchingSessions.length > 0) {
                return { ...group, sessions: matchingSessions };
            }
            return null;
        }).filter(Boolean);
    }, [groupedDrafts, modalSearchTerm]);

    const usersMap = useMemo(() => new Map(allUsers.map(u => [u.id, u])), [allUsers]);
    const enrichedTasks = useMemo(() => { const customerMap = new Map([...masterCustomers, ...masterSuppliers].map(c => [c.id, c.name])); const tasksWithActiveAssignee = allScopedTasks.filter(task => usersMap.has(task.assigneeId)); return tasksWithActiveAssignee.map(task => { const user = usersMap.get(task.assigneeId); const vendor = [...masterCustomers, ...masterSuppliers].find(v => v.id === task.customerId); return { task: { ...task, customerName: task.customerId ? customerMap.get(task.customerId) : null, vendorTypeId: vendor ? vendor.vendor_type : null }, user: user }; }); }, [allScopedTasks, usersMap, masterCustomers, masterSuppliers]);
    const enrichedAndFilteredTasks = useMemo(() => { return enrichedTasks.filter(item => taskMatchesFilters(item.task, item.user, filters)).sort((a, b) => new Date(b.task.createdAt) - new Date(a.task.createdAt)); }, [enrichedTasks, filters]);
    const { statusOptions, priorityOptions, projectOptions, categoryOptions, departmentOptions, userOptions, defaultUserLabel, vendorTypeOptions, yearOptions, monthOptionsForFilter } = useMemo(() => {
        const createDynamicOptions = (keyToExclude) => {
            const tempFilters = { ...filters, [keyToExclude]: [] };
            const availableTasks = enrichedTasks.filter(item => taskMatchesFilters(item.task, item.user, tempFilters));
            let valueSet;
            if (keyToExclude === 'department') {
                const departmentNames = availableTasks.map(item => item.user.department?.departmentName).filter(Boolean);
                valueSet = new Set(departmentNames);
            } else {
                valueSet = new Set(availableTasks.map(item => item.task[keyToExclude]).filter(Boolean));
            }
            return Array.from(valueSet).map(value => ({ value: normalizeForComparison(value), label: String(value) })).sort((a, b) => (a.label || '').localeCompare(b.label || ''));
        };

        let staticUserOpts = [];
        let userLabel = 'Select User';
        const user = getLoggedInUser();
        if (isSuperAdmin) {
            staticUserOpts = allUsers.map(u => ({ value: String(u.id), label: u.name })).sort((a, b) => (a.label || '').localeCompare(b.label || ''));
            userLabel = 'All Users';
        } else if (user && fullHierarchy.length > 0) {
            const findUserNode = (nodes, userId) => { for (const node of nodes) { if (node.id === userId) return node; const found = findUserNode(node.children || [], userId); if (found) return found; } return null; };
            const userNode = findUserNode(fullHierarchy, user.id);
            const subordinateIds = userNode ? getSubordinateIds(userNode) : [user.id];
            const subordinateIdsSet = new Set(subordinateIds);
            staticUserOpts = allUsers.filter(u => subordinateIdsSet.has(u.id)).map(u => ({ value: String(u.id), label: u.name })).sort((a, b) => (a.label || '').localeCompare(b.label || ''));
            userLabel = userNode?.children?.length > 0 ? 'My Team' : 'My Tasks';
        }
        if (filterUserId.length === 1) {
            userLabel = allUsers.find(u => String(u.id) === filterUserId[0])?.name || 'Selected User';
        } else if (filterUserId.length > 1) {
            userLabel = `${filterUserId.length} Users Selected`;
        }

        const dateSets = { years: new Set(), months: new Set() };
        enrichedAndFilteredTasks.forEach(({ task }) => {
            if (task.createdAt) {
                const financialYear = getFinancialYear(task.createdAt);
                if (financialYear) dateSets.years.add(financialYear);
                dateSets.months.add(new Date(task.createdAt).getMonth());
            }
        });

        // UPDATED MONTH OPTIONS LOGIC: Show all months (1-12) with correct labels
        const monthOpts = DATE_PICKER_MONTHS.map(m => ({ value: m.value, label: m.name }));

        const yearOpts = Array.from(dateSets.years).sort((a, b) => (b || '').localeCompare(a || '')).map(y => ({ value: y, label: y }));
        const vendOptions = masterVendorTypes.map(vt => ({ value: String(vt.id), label: vt.value })).sort((a, b) => (a.label || '').localeCompare(b.label || ''));

        const baseStatusOptions = createDynamicOptions('status');
        const hasUnderReview = baseStatusOptions.some(opt => opt.value === 'under_review');
        const finalStatusOptions = hasUnderReview
            ? baseStatusOptions
            : [...baseStatusOptions, { value: 'under_review', label: 'Under Review' }].sort((a, b) => (a.label || '').localeCompare(b.label || ''));

        return {
            statusOptions: finalStatusOptions,
            priorityOptions: createDynamicOptions('priority'),
            projectOptions: createDynamicOptions('projectName'),
            categoryOptions: createDynamicOptions('category'),
            departmentOptions: createDynamicOptions('department'),
            userOptions: staticUserOpts,
            defaultUserLabel: userLabel,
            vendorTypeOptions: vendOptions,
            yearOptions: yearOpts,
            monthOptionsForFilter: monthOpts,
        };
    }, [enrichedTasks, filters, allUsers, isSuperAdmin, fullHierarchy, masterVendorTypes, enrichedAndFilteredTasks]);

    const customerVendorTypeId = useMemo(() => masterVendorTypes.find(vt => vt.value?.toLowerCase() === 'customer')?.id, [masterVendorTypes]);
    const supplierVendorTypeId = useMemo(() => masterVendorTypes.find(vt => vt.value?.toLowerCase() === 'supplier')?.id, [masterVendorTypes]);
    const displayedHierarchy = useMemo(() => { if (viewMode !== 'tree' || fullHierarchy.length === 0 || enrichedAndFilteredTasks.length === 0) return []; const hierarchyCopy = JSON.parse(JSON.stringify(fullHierarchy)); const nodeMap = new Map(); function traverseAndMap(nodes) { for (const node of nodes) { node.tasks = []; nodeMap.set(node.id, node); if (node.children) traverseAndMap(node.children); } } traverseAndMap(hierarchyCopy); enrichedAndFilteredTasks.forEach(item => { if (item.task.assigneeId && nodeMap.has(item.task.assigneeId)) { nodeMap.get(item.task.assigneeId).tasks.push(item.task); } }); return hierarchyCopy; }, [fullHierarchy, enrichedAndFilteredTasks, viewMode]);


    if (isInitialising) {
        return (<div className="tasks-list-page-loading"><div className="loader-spinner"></div><p>Loading application...</p></div>);
    }

    return (
        <div className="tasks-list-page">
            <TemplatePreviewModal
                isOpen={isPreviewModalOpen}
                onClose={handleClosePreviewModal}
                template={templateToPreview}
            />
            <Modal
                isOpen={isTemplateSelectionModalOpen}
                onClose={() => setIsTemplateSelectionModalOpen(false)}
                title="Select a Project Template"
            >
                <div className="template-modal-search">
                    <IoSearchOutline />
                    <input
                        type="text"
                        placeholder="Search templates by name or date..."
                        value={modalSearchTerm}
                        onChange={(e) => setModalSearchTerm(e.target.value)}
                        autoFocus
                    />
                </div>
                <div className="template-options-list">
                    {filteredProjectTemplates.length > 0 ? (
                        filteredProjectTemplates.map(template => (
                            <div key={template.projectTemplateId} className="template-list-item">
                                <div className="template-item-clickable-area" onClick={() => handleTemplateSelect(template.projectTemplateId)}>
                                    <div className="template-item-icon"><IoDocumentsOutline /></div>
                                    <div className="template-item-details">
                                        <div className="template-item-name">{template.projectTemplateName}</div>
                                        <div className="template-item-meta">
                                            <span>Created: {formatModalDate(template.createdAt)}</span>
                                            <span>Updated: {formatModalDate(template.updatedAt)}</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="template-item-action-wrapper">
                                    <button
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            handleOpenPreviewModal(template);
                                        }}
                                        className="action-btn preview-btn"
                                        title="Preview Template"
                                    >
                                        <IoEyeOutline size={18} />
                                    </button>
                                    <IoChevronForwardOutline className="forward-icon" onClick={() => handleTemplateSelect(template.projectTemplateId)} />
                                </div>
                            </div>
                        ))
                    ) : (
                        <div className="template-option-message empty">
                            <IoDocumentsOutline />
                            <span>{modalSearchTerm ? 'No templates found matching your search.' : 'No templates found.'}</span>
                        </div>
                    )}
                </div>
            </Modal>

            <Modal
                isOpen={isDraftSelectionModalOpen}
                onClose={() => setIsDraftSelectionModalOpen(false)}
                title="Select a Draft to Edit"
            >
                <div className="template-modal-search">
                    <IoSearchOutline />
                    <input
                        type="text"
                        placeholder="Search by template, draft title, creator, or assignee..."
                        value={modalSearchTerm}
                        onChange={(e) => setModalSearchTerm(e.target.value)}
                        autoFocus
                    />
                </div>
                <div className="template-options-list">
                    {isCheckingForDrafts ? (
                        <div className="template-option-message">
                            <div className="loader-spinner small"></div>
                            <span>Checking for your team's drafts...</span>
                        </div>
                    ) : filteredGroupedDrafts.length > 0 ? (
                        filteredGroupedDrafts.map(group => (
                            <div key={group.template.projectTemplateId} className="template-group-container">
                                <div
                                    className="template-list-item is-expandable"
                                    onClick={() => handleToggleTemplateExpansion(group.template.projectTemplateId)}
                                >
                                    <div className="template-item-icon"><IoDocumentsOutline /></div>
                                    <div className="template-item-details">
                                        <div className="template-item-name">{group.template.projectTemplateName}</div>
                                        <div className="template-item-meta">
                                            <span>{group.sessions.length} draft(s) saved</span>
                                        </div>
                                    </div>
                                    <div className="template-item-action">
                                        <IoChevronDown className={`expansion-arrow ${expandedTemplateId === group.template.projectTemplateId ? 'expanded' : ''}`} />
                                    </div>
                                </div>

                                {expandedTemplateId === group.template.projectTemplateId && (
                                    <div className="draft-sessions-list">
                                        {group.sessions.map(session => (
                                            <div key={session.savedAt} className="template-list-item-draft">
                                                <div className="template-item-clickable-area" onClick={() => handleEditDraftSelect(session)}>
                                                    <div className="template-item-icon draft"><IoCreateOutline /></div>
                                                    <div className="template-item-details">
                                                        <div className="template-item-name">
                                                            <span className="draft-title">{session.displayName}</span>
                                                        </div>
                                                        <div className="template-item-meta">
                                                            <span>Saved: {formatModalDate(session.savedAt)}</span>
                                                            {session.createdBy && <span>By: {session.createdBy}</span>}
                                                            {session.assigneeName && <span>Assigned to: {session.assigneeName}</span>}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="template-item-action-wrapper">
                                                    {(isSuperAdmin || isReportingManager) && (
                                                        <button
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                openAssignDraftModal(session);
                                                            }}
                                                            className="action-btn assign-btn"
                                                            title="Assign Draft"
                                                        >
                                                            <IoPersonAddOutline size={16} />
                                                        </button>
                                                    )}
                                                    <button
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            openDeleteDraftConfirm(session);
                                                        }}
                                                        className="action-btn delete-btn"
                                                        title="Delete Draft"
                                                    >
                                                        <IoTrashOutline size={16} />
                                                    </button>
                                                    <IoChevronForwardOutline className="forward-icon" onClick={() => handleEditDraftSelect(session)} />
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>
                        ))
                    ) : (
                        <div className="template-option-message empty">
                            <IoCreateOutline />
                            <span>{groupedDrafts.length > 0 ? 'No drafts found matching your search.' : 'No saved drafts found for you or your team.'}</span>
                        </div>
                    )}
                </div>
            </Modal>

            <ConfirmationModal
                isOpen={isDraftDeleteConfirmOpen}
                onClose={() => setIsDraftDeleteConfirmOpen(false)}
                onConfirm={confirmDeleteDraft}
                title="Confirm Deletion"
            >
                <p>Are you sure you want to delete this draft session?</p>
                {draftToDelete && (
                    <div className="draft-delete-details">
                        <strong>{draftToDelete.displayName}</strong>
                        <span>(Template: {draftToDelete.template.projectTemplateName})</span>
                        <span>Saved: {formatModalDate(draftToDelete.savedAt)}</span>
                    </div>
                )}
                <p className="warning-text">This will delete all tasks in this draft. This action cannot be undone.</p>
            </ConfirmationModal>

            <AssignDraftModal
                isOpen={isAssignDraftModalOpen}
                onClose={() => setIsAssignDraftModalOpen(false)}
                onConfirm={confirmAssignDraft}
                users={subordinateUsers}
                title="Assign Draft To"
            />


            <div className="tasks-list-header-static">
                <div className="page-header-tasks">
                    <div className="header-content">
                        <h1>Team Tasks</h1>
                        <div className="view-toggle">
                            <button className={`view-btn ${viewMode === 'tree' ? 'active' : ''}`} onClick={() => setViewMode('tree')} title="Tree View"><IoGitNetworkOutline /></button>
                            <button className={`view-btn ${viewMode === 'compact-list' ? 'active' : ''}`} onClick={() => setViewMode('compact-list')} title="Compact List View"><IoReorderFourOutline /></button>
                            <button className={`view-btn ${viewMode === 'list' ? 'active' : ''}`} onClick={() => setViewMode('list')} title="List View"><IoListOutline /></button>
                            <button className={`view-btn ${viewMode === 'grid' ? 'active' : ''}`} onClick={() => setViewMode('grid')} title="Grid View"><IoGridOutline /></button>
                        </div>
                    </div>
                    <div className="header-actions">
                        {companyKeyword === 'ZO' && (
                            <>
                                <button onClick={handleOpenDraftsModal} className="create-task-button-header secondary-btn">
                                    <IoCreateOutline /> My Drafts
                                </button>
                                <button onClick={() => { setIsTemplateSelectionModalOpen(true); setModalSearchTerm(''); }} className="create-task-button-header template-btn">
                                    <IoDocumentsOutline /> Use Template
                                </button>
                            </>
                        )}
                        <Link to="/tasks/create" className="create-task-button-header">
                            <IoAdd /> Create Task
                        </Link>
                    </div>
                </div>

                <div className="page-filters-container">
                    <div className="search-row"><IoSearchOutline className="filter-icon" /><input type="text" placeholder="Search tasks, users, projects, customers..." value={searchTerm} onChange={handleSearchChange} /></div>
                    <div className="dropdown-filters-row">
                        <MultiSelectDropdown icon={<IoPeopleOutline className="filter-icon" />} options={userOptions} value={filterUserId} onChange={handleUserChange} defaultLabel={defaultUserLabel} />
                        <MultiSelectDropdown icon={<IoPricetagOutline className="filter-icon" />} options={vendorTypeOptions} value={filterVendorTypes} onChange={handleVendorTypesChange} defaultLabel="All Vendor Types" />
                        {customerVendorTypeId && filterVendorTypes.includes(String(customerVendorTypeId)) && (<MultiSelectDropdown icon={<IoBusinessOutline className="filter-icon" />} options={masterCustomers.map(c => ({ value: String(c.id), label: c.name }))} value={filterCustomers} onChange={handleCustomersChange} defaultLabel="All Customers" />)}
                        {supplierVendorTypeId && filterVendorTypes.includes(String(supplierVendorTypeId)) && (<MultiSelectDropdown icon={<IoPeopleOutline className="filter-icon" />} options={masterSuppliers.map(s => ({ value: String(s.id), label: s.name }))} value={filterSuppliers} onChange={handleSuppliersChange} defaultLabel="All Suppliers" />)}
                        <MultiSelectDropdown icon={<IoCheckmarkCircleOutline className="filter-icon" />} options={statusOptions} value={filterStatus} onChange={handleStatusChange} defaultLabel="All Statuses" />
                        <MultiSelectDropdown icon={<IoFlagOutline className="filter-icon" />} options={priorityOptions} value={filterPriority} onChange={handlePriorityChange} defaultLabel="All Priorities" />
                        <MultiSelectDropdown icon={<IoBriefcaseOutline className="filter-icon" />} options={projectOptions} value={filterProjectName} onChange={handleProjectChange} defaultLabel="All Projects" />
                        <MultiSelectDropdown icon={<IoBusinessOutline className="filter-icon" />} options={departmentOptions} value={filterDepartment} onChange={handleDepartmentChange} defaultLabel="All Departments" />
                        <MultiSelectDropdown icon={<IoPricetagOutline className="filter-icon" />} options={categoryOptions} value={filterCategory} onChange={handleCategoryChange} defaultLabel="All Categories" />
                    </div>
                    <div className="actions-row">
                        <span className="date-filter-label">Filter by Date</span>
                        <MultiSelectDropdown icon={<IoCalendarOutline className="filter-icon" />} options={yearOptions} value={filterYear} onChange={handleYearChange} defaultLabel="All Years" />
                        <MultiSelectDropdown icon={<IoCalendarOutline className="filter-icon" />} options={monthOptionsForFilter} value={filterMonth} onChange={handleMonthChange} defaultLabel="All Months" />
                        <div className="date-filter-group"><select value={dateFilterType} onChange={handleDateTypeChange}><option value="none">-- Date Type --</option><option value="created">Created</option><option value="completed">Completed</option><option value="due">Due</option></select></div>
                        <div className="date-filter-group"><label>From</label>{dateFilterType === 'none' ? (<div className="date-placeholder">dd/mm/yyyy</div>) : (<div className="custom-date-inputs"><select value={fromDay} onChange={(e) => setFromDay(e.target.value)}>{daysInFromMonth.map(day => <option key={day} value={day}>{day}</option>)}</select><select value={fromMonth} onChange={(e) => setFromMonth(e.target.value)}>{DATE_PICKER_MONTHS.map(month => <option key={month.value} value={month.value}>{month.name}</option>)}</select><select value={fromYear} onChange={(e) => setFromYear(e.target.value)}>{years.map(year => <option key={year} value={year}>{year}</option>)}</select></div>)}</div>
                        <div className="date-filter-group"><label>To</label>{dateFilterType === 'none' ? (<div className="date-placeholder">dd/mm/yyyy</div>) : (<div className="custom-date-inputs"><select value={toDay} onChange={(e) => setToDay(e.target.value)}>{daysInToMonth.map(day => <option key={day} value={day}>{day}</option>)}</select><select value={toMonth} onChange={(e) => setToMonth(e.target.value)}>{DATE_PICKER_MONTHS.map(month => <option key={month.value} value={month.value}>{month.name}</option>)}</select><select value={toYear} onChange={(e) => setToYear(e.target.value)}>{years.map(year => <option key={year} value={year}>{year}</option>)}</select></div>)}</div>
                        <div className="view-and-reset-actions"><button className="reset-filters-btn" onClick={handleResetFilters} title="Reset all filters to default"><IoRefresh />Reset</button></div>
                    </div>
                </div>
            </div>

            <div className="notification-area">
                {infoMessage && <div className="info-message">{infoMessage}</div>}
                {error && <div className="error-message">{error}</div>}
                {companyKeyword === 'ZO' && templateError && <div className="error-message">{templateError}</div>}
            </div>

            <div className={`content-container ${viewMode === 'compact-list' ? 'is-compact-view' : ''}`}>{isTasksLoading && allScopedTasks.length === 0 ? (<div className="tasks-grid-view-container">{Array.from({ length: 12 }).map((_, i) => <TaskCardSkeleton key={i} />)}</div>) : (<> {(enrichedAndFilteredTasks.length > 0 || Object.values(filters).some(val => Array.isArray(val) ? val.length > 0 : !!val)) && (<>{viewMode === 'tree' && (<> <div className="hierarchy-container">{displayedHierarchy.map((node) => (<UserNode key={node.id} node={node} isSuperAdmin={isSuperAdmin} onTaskDelete={handleTaskDelete} onCloneTask={handleCloneTask} onTaskSubtask={handleCreateSubtask} companyKeyword={companyKeyword} onToggleSubtasks={handleToggleSubtasks} expandedSubtasks={expandedSubtasks} targetTaskId={targetTaskId} filters={filters} taggedTaskIds={taggedTaskIds} />))}</div> <div className="load-more-container"><button onClick={handleLoadMore} className="load-more-btn" disabled={isLoadingMore || !hasMore}>{isLoadingMore ? 'Loading...' : (hasMore ? 'Load More' : 'No more tasks')}</button></div></>)}{viewMode === 'compact-list' && (<div className="tasks-compact-list-scroll-wrapper"><div className="tasks-compact-list-header"><div className="task-compact-list-id-section">ID</div><div className="task-compact-list-title-section">Title</div><div className="task-compact-list-project-section">Project</div><div className="task-compact-list-customer-section">Customer</div>{companyKeyword !== 'PL' && <div className="task-compact-list-subtask-section">Subtasks</div>}<div className="task-compact-list-category-section">Category</div><div className="task-compact-list-priority-section">Priority</div><div className="task-compact-list-status-section">Status</div><div className="task-compact-list-date-section">Due Date</div><div className="task-compact-list-user-section">Assignee</div><div className="task-compact-list-actions">Actions</div></div><div className="tasks-compact-list-container">{enrichedAndFilteredTasks.map((item, index) => (<div key={item.task.taskId} className="compact-list-item-wrapper"><TaskCompactListItem item={item} isSuperAdmin={isSuperAdmin} onTaskDelete={handleTaskDelete} onCloneTask={handleCloneTask} onTaskSubtask={handleCreateSubtask} companyKeyword={companyKeyword} index={index} isTargetTask={targetTaskId && String(item.task.taskId) === String(targetTaskId)} onToggleSubtasks={handleToggleSubtasks} subtaskData={expandedSubtasks[item.task.taskId]} navigate={navigate} isTagged={taggedTaskIds.has(item.task.taskId)} />{companyKeyword !== 'PL' && <SubtaskList parentTaskId={item.task.taskId} subtaskData={expandedSubtasks[item.task.taskId]} navigate={navigate} isSuperAdmin={isSuperAdmin} onTaskDelete={handleTaskDelete} />}</div>))}</div><div className="load-more-container"><button onClick={handleLoadMore} className="load-more-btn" disabled={isLoadingMore || !hasMore}>{isLoadingMore ? 'Loading...' : (hasMore ? 'Load More' : 'No more tasks')}</button></div></div>)}{(viewMode === 'list' || viewMode === 'grid') && (<> <div className={viewMode === 'list' ? "tasks-list-view-container" : "tasks-grid-view-container"}>{enrichedAndFilteredTasks.map((item, index) => (<TaskCard key={item.task.taskId} item={item} isSuperAdmin={isSuperAdmin} onTaskDelete={handleTaskDelete} onCloneTask={handleCloneTask} onTaskSubtask={handleCreateSubtask} companyKeyword={companyKeyword} onToggleSubtasks={handleToggleSubtasks} subtaskData={expandedSubtasks[item.task.taskId]} index={index} viewMode={viewMode} isTargetTask={targetTaskId && String(item.task.taskId) === String(targetTaskId)} isTagged={taggedTaskIds.has(item.task.taskId)} />))}</div> <div className="load-more-container"><button onClick={handleLoadMore} className="load-more-btn" disabled={isLoadingMore || !hasMore}>{isLoadingMore ? 'Loading...' : (hasMore ? 'Load More' : 'No more tasks')}</button></div></>)}</>)}{enrichedAndFilteredTasks.length === 0 && !isTasksLoading && (<div className="no-tasks-found-container">{filterTaskId ? (<h3>Task not found. It may be on a subsequent page or not within your current scope.</h3>) : (<h3>No tasks match the current filters.</h3>)}<p>Try adjusting your search or filter criteria.</p><button onClick={handleResetFilters} className="reset-filters-btn-empty"><IoRefresh /> Reset Filters</button></div>)}</>)}</div>
        </div>
    );
};
export default TasksListPage;
